(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// Import SASS

// Detect mobile device
function $6e15c66c5bf5d010$export$8de52386ea28ce8f() {
    var check = false;
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
function $6e15c66c5bf5d010$export$5dacdde460c8d918() {
    if (window.NodeList && !NodeList.prototype.forEach) NodeList.prototype.forEach = function(callback, thisArg) {
        thisArg = thisArg || window;
        for(var i = 0; i < this.length; i++)callback.call(thisArg, this[i], i, this);
    };
}
function $6e15c66c5bf5d010$export$7a5418d73bdac342(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}


// don't go to parent menu-item on click
if ((0, $6e15c66c5bf5d010$export$8de52386ea28ce8f)() == true) {
    var $440417c21a8676fa$var$parents = document.querySelectorAll(".menu-item-has-children > a");
    var $440417c21a8676fa$var$_iteratorNormalCompletion = true, $440417c21a8676fa$var$_didIteratorError = false, $440417c21a8676fa$var$_iteratorError = undefined;
    try {
        for(var $440417c21a8676fa$var$_iterator = $440417c21a8676fa$var$parents[Symbol.iterator](), $440417c21a8676fa$var$_step; !($440417c21a8676fa$var$_iteratorNormalCompletion = ($440417c21a8676fa$var$_step = $440417c21a8676fa$var$_iterator.next()).done); $440417c21a8676fa$var$_iteratorNormalCompletion = true){
            var $440417c21a8676fa$var$parent = $440417c21a8676fa$var$_step.value;
            $440417c21a8676fa$var$parent.addEventListener("click", function(e) {
                return e.preventDefault();
            });
        }
    } catch (err) {
        $440417c21a8676fa$var$_didIteratorError = true;
        $440417c21a8676fa$var$_iteratorError = err;
    } finally{
        try {
            if (!$440417c21a8676fa$var$_iteratorNormalCompletion && $440417c21a8676fa$var$_iterator.return != null) {
                $440417c21a8676fa$var$_iterator.return();
            }
        } finally{
            if ($440417c21a8676fa$var$_didIteratorError) {
                throw $440417c21a8676fa$var$_iteratorError;
            }
        }
    }
}
// Hamburger menu
var $440417c21a8676fa$var$toggle = document.querySelector(".menu-toggle");
var $440417c21a8676fa$var$nav = document.querySelector(".main-navigation");
$440417c21a8676fa$var$toggle.addEventListener("click", function() {
    return $440417c21a8676fa$var$nav.classList.toggle("active");
});


/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */ (function() {
    var isIe = /(trident|msie)/i.test(navigator.userAgent);
    if (isIe && document.getElementById && window.addEventListener) window.addEventListener("hashchange", function() {
        var id = location.hash.substring(1), element;
        if (!/^[A-z0-9_-]+$/.test(id)) return;
        element = document.getElementById(id);
        if (element) {
            if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) element.tabIndex = -1;
            element.focus();
        }
    }, false);
})();


var $31467fba5e5d38e9$exports = {};
/*! npm.im/object-fit-images 3.2.4 */ "use strict";
var $31467fba5e5d38e9$var$OFI = "bfred-it:object-fit-images";
var $31467fba5e5d38e9$var$propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
var $31467fba5e5d38e9$var$testImg = typeof Image === "undefined" ? {
    style: {
        "object-position": 1
    }
} : new Image();
var $31467fba5e5d38e9$var$supportsObjectFit = "object-fit" in $31467fba5e5d38e9$var$testImg.style;
var $31467fba5e5d38e9$var$supportsObjectPosition = "object-position" in $31467fba5e5d38e9$var$testImg.style;
var $31467fba5e5d38e9$var$supportsOFI = "background-size" in $31467fba5e5d38e9$var$testImg.style;
var $31467fba5e5d38e9$var$supportsCurrentSrc = typeof $31467fba5e5d38e9$var$testImg.currentSrc === "string";
var $31467fba5e5d38e9$var$nativeGetAttribute = $31467fba5e5d38e9$var$testImg.getAttribute;
var $31467fba5e5d38e9$var$nativeSetAttribute = $31467fba5e5d38e9$var$testImg.setAttribute;
var $31467fba5e5d38e9$var$autoModeEnabled = false;
function $31467fba5e5d38e9$var$createPlaceholder(w, h) {
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E";
}
function $31467fba5e5d38e9$var$polyfillCurrentSrc(el) {
    if (el.srcset && !$31467fba5e5d38e9$var$supportsCurrentSrc && window.picturefill) {
        var pf = window.picturefill._;
        // parse srcset with picturefill where currentSrc isn't available
        if (!el[pf.ns] || !el[pf.ns].evaled) // force synchronous srcset parsing
        pf.fillImg(el, {
            reselect: true
        });
        if (!el[pf.ns].curSrc) {
            // force picturefill to parse srcset
            el[pf.ns].supported = false;
            pf.fillImg(el, {
                reselect: true
            });
        }
        // retrieve parsed currentSrc, if any
        el.currentSrc = el[pf.ns].curSrc || el.src;
    }
}
function $31467fba5e5d38e9$var$getStyle(el) {
    var style = getComputedStyle(el).fontFamily;
    var parsed;
    var props = {};
    while((parsed = $31467fba5e5d38e9$var$propRegex.exec(style)) !== null)props[parsed[1]] = parsed[2];
    return props;
}
function $31467fba5e5d38e9$var$setPlaceholder(img, width, height) {
    // Default: fill width, no height
    var placeholder = $31467fba5e5d38e9$var$createPlaceholder(width || 1, height || 0);
    // Only set placeholder if it's different
    if ($31467fba5e5d38e9$var$nativeGetAttribute.call(img, "src") !== placeholder) $31467fba5e5d38e9$var$nativeSetAttribute.call(img, "src", placeholder);
}
function $31467fba5e5d38e9$var$onImageReady(img, callback) {
    // naturalWidth is only available when the image headers are loaded,
    // this loop will poll it every 100ms.
    if (img.naturalWidth) callback(img);
    else setTimeout($31467fba5e5d38e9$var$onImageReady, 100, img, callback);
}
function $31467fba5e5d38e9$var$fixOne(el) {
    var style = $31467fba5e5d38e9$var$getStyle(el);
    var ofi = el[$31467fba5e5d38e9$var$OFI];
    style["object-fit"] = style["object-fit"] || "fill"; // default value
    // Avoid running where unnecessary, unless OFI had already done its deed
    if (!ofi.img) {
        // fill is the default behavior so no action is necessary
        if (style["object-fit"] === "fill") return;
        // Where object-fit is supported and object-position isn't (Safari < 10)
        if (!ofi.skipTest && // unless user wants to apply regardless of browser support
        $31467fba5e5d38e9$var$supportsObjectFit && // if browser already supports object-fit
        !style["object-position"] // unless object-position is used
        ) return;
    }
    // keep a clone in memory while resetting the original to a blank
    if (!ofi.img) {
        ofi.img = new Image(el.width, el.height);
        ofi.img.srcset = $31467fba5e5d38e9$var$nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
        ofi.img.src = $31467fba5e5d38e9$var$nativeGetAttribute.call(el, "data-ofi-src") || el.src;
        // preserve for any future cloneNode calls
        // https://github.com/bfred-it/object-fit-images/issues/53
        $31467fba5e5d38e9$var$nativeSetAttribute.call(el, "data-ofi-src", el.src);
        if (el.srcset) $31467fba5e5d38e9$var$nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
        $31467fba5e5d38e9$var$setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);
        // remove srcset because it overrides src
        if (el.srcset) el.srcset = "";
        try {
            $31467fba5e5d38e9$var$keepSrcUsable(el);
        } catch (err) {
            if (window.console) console.warn("https://bit.ly/ofi-old-browser");
        }
    }
    $31467fba5e5d38e9$var$polyfillCurrentSrc(ofi.img);
    el.style.backgroundImage = 'url("' + (ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"') + '")';
    el.style.backgroundPosition = style["object-position"] || "center";
    el.style.backgroundRepeat = "no-repeat";
    el.style.backgroundOrigin = "content-box";
    if (/scale-down/.test(style["object-fit"])) $31467fba5e5d38e9$var$onImageReady(ofi.img, function() {
        if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) el.style.backgroundSize = "contain";
        else el.style.backgroundSize = "auto";
    });
    else el.style.backgroundSize = style["object-fit"].replace("none", "auto").replace("fill", "100% 100%");
    $31467fba5e5d38e9$var$onImageReady(ofi.img, function(img) {
        $31467fba5e5d38e9$var$setPlaceholder(el, img.naturalWidth, img.naturalHeight);
    });
}
function $31467fba5e5d38e9$var$keepSrcUsable(el) {
    var descriptors = {
        get: function get(prop) {
            return el[$31467fba5e5d38e9$var$OFI].img[prop ? prop : "src"];
        },
        set: function set(value, prop) {
            el[$31467fba5e5d38e9$var$OFI].img[prop ? prop : "src"] = value;
            $31467fba5e5d38e9$var$nativeSetAttribute.call(el, "data-ofi-" + prop, value); // preserve for any future cloneNode
            $31467fba5e5d38e9$var$fixOne(el);
            return value;
        }
    };
    Object.defineProperty(el, "src", descriptors);
    Object.defineProperty(el, "currentSrc", {
        get: function get() {
            return descriptors.get("currentSrc");
        }
    });
    Object.defineProperty(el, "srcset", {
        get: function get() {
            return descriptors.get("srcset");
        },
        set: function set(ss) {
            return descriptors.set(ss, "srcset");
        }
    });
}
function $31467fba5e5d38e9$var$hijackAttributes() {
    function getOfiImageMaybe(el, name) {
        return el[$31467fba5e5d38e9$var$OFI] && el[$31467fba5e5d38e9$var$OFI].img && (name === "src" || name === "srcset") ? el[$31467fba5e5d38e9$var$OFI].img : el;
    }
    if (!$31467fba5e5d38e9$var$supportsObjectPosition) {
        HTMLImageElement.prototype.getAttribute = function(name) {
            return $31467fba5e5d38e9$var$nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
        };
        HTMLImageElement.prototype.setAttribute = function(name, value) {
            return $31467fba5e5d38e9$var$nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
        };
    }
}
function $31467fba5e5d38e9$var$fix(imgs, opts) {
    var startAutoMode = !$31467fba5e5d38e9$var$autoModeEnabled && !imgs;
    opts = opts || {};
    imgs = imgs || "img";
    if ($31467fba5e5d38e9$var$supportsObjectPosition && !opts.skipTest || !$31467fba5e5d38e9$var$supportsOFI) return false;
    // use imgs as a selector or just select all images
    if (imgs === "img") imgs = document.getElementsByTagName("img");
    else if (typeof imgs === "string") imgs = document.querySelectorAll(imgs);
    else if (!("length" in imgs)) imgs = [
        imgs
    ];
    // apply fix to all
    for(var i = 0; i < imgs.length; i++){
        imgs[i][$31467fba5e5d38e9$var$OFI] = imgs[i][$31467fba5e5d38e9$var$OFI] || {
            skipTest: opts.skipTest
        };
        $31467fba5e5d38e9$var$fixOne(imgs[i]);
    }
    if (startAutoMode) {
        document.body.addEventListener("load", function(e) {
            if (e.target.tagName === "IMG") $31467fba5e5d38e9$var$fix(e.target, {
                skipTest: opts.skipTest
            });
        }, true);
        $31467fba5e5d38e9$var$autoModeEnabled = true;
        imgs = "img"; // reset to a generic selector for watchMQ
    }
    // if requested, watch media queries for object-fit change
    if (opts.watchMQ) window.addEventListener("resize", $31467fba5e5d38e9$var$fix.bind(null, imgs, {
        skipTest: opts.skipTest
    }));
}
$31467fba5e5d38e9$var$fix.supportsObjectFit = $31467fba5e5d38e9$var$supportsObjectFit;
$31467fba5e5d38e9$var$fix.supportsObjectPosition = $31467fba5e5d38e9$var$supportsObjectPosition;
$31467fba5e5d38e9$var$hijackAttributes();
$31467fba5e5d38e9$exports = $31467fba5e5d38e9$var$fix;


// Object.keys
var $841e85ee868dd0d4$var$win = window;
var $841e85ee868dd0d4$export$27f233d61a9e2fa4 = $841e85ee868dd0d4$var$win.requestAnimationFrame || $841e85ee868dd0d4$var$win.webkitRequestAnimationFrame || $841e85ee868dd0d4$var$win.mozRequestAnimationFrame || $841e85ee868dd0d4$var$win.msRequestAnimationFrame || function(cb) {
    return setTimeout(cb, 16);
};


var $9960623eeb62d695$var$win = window;
var $9960623eeb62d695$export$75aab3dbee8deceb = $9960623eeb62d695$var$win.cancelAnimationFrame || $9960623eeb62d695$var$win.mozCancelAnimationFrame || function(id) {
    clearTimeout(id);
};


function $8def800bd2c631ba$export$8b58be045bf06082() {
    var obj, name, copy, target = arguments[0] || {}, i = 1, length = arguments.length;
    for(; i < length; i++){
        if ((obj = arguments[i]) !== null) for(name in obj){
            copy = obj[name];
            if (target === copy) continue;
            else if (copy !== undefined) target[name] = copy;
        }
    }
    return target;
}


function $35e19be817102b97$export$79d1167a24e4e930(value) {
    return [
        "true",
        "false"
    ].indexOf(value) >= 0 ? JSON.parse(value) : value;
}


function $2033929a7fec2873$export$1f73f60bdb811cb1(storage, key, value, access) {
    if (access) try {
        storage.setItem(key, value);
    } catch (e) {}
    return value;
}


function $d7f329ede83197d7$export$ff0ccbbb2d1923f6() {
    var id = window.tnsId;
    window.tnsId = !id ? 1 : id + 1;
    return "tns" + window.tnsId;
}


// get css-calc 
// @return - false | calc | -webkit-calc | -moz-calc
// @usage - var calc = getCalc(); 
function $b7572e32da8ee13a$export$135b49d4bc2964c6() {
    var doc = document, body = doc.body;
    if (!body) {
        body = doc.createElement("body");
        body.fake = true;
    }
    return body;
}


var $7979bb3e1890db7f$export$9dfbf2fa8806212d = document.documentElement;


function $58ed177cc807d047$export$4078b67b5eba0c5(body) {
    var docOverflow = "";
    if (body.fake) {
        docOverflow = (0, $7979bb3e1890db7f$export$9dfbf2fa8806212d).style.overflow;
        //avoid crashing IE8, if background image is used
        body.style.background = "";
        //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
        body.style.overflow = (0, $7979bb3e1890db7f$export$9dfbf2fa8806212d).style.overflow = "hidden";
        (0, $7979bb3e1890db7f$export$9dfbf2fa8806212d).appendChild(body);
    }
    return docOverflow;
}



function $af64f50f3d11d5e1$export$81b27fa331809b9b(body, docOverflow) {
    if (body.fake) {
        body.remove();
        (0, $7979bb3e1890db7f$export$9dfbf2fa8806212d).style.overflow = docOverflow;
        // Trigger layout so kinetic scrolling isn't disabled in iOS6+
        // eslint-disable-next-line
        (0, $7979bb3e1890db7f$export$9dfbf2fa8806212d).offsetHeight;
    }
}


function $155687d682cfd223$export$42bfa9b2d4dad91a() {
    var doc = document, body = (0, $b7572e32da8ee13a$export$135b49d4bc2964c6)(), docOverflow = (0, $58ed177cc807d047$export$4078b67b5eba0c5)(body), div = doc.createElement("div"), result = false;
    body.appendChild(div);
    try {
        var str = "(10px * 10)", vals = [
            "calc" + str,
            "-moz-calc" + str,
            "-webkit-calc" + str
        ], val;
        for(var i = 0; i < 3; i++){
            val = vals[i];
            div.style.width = val;
            if (div.offsetWidth === 100) {
                result = val.replace(str, "");
                break;
            }
        }
    } catch (e) {}
    body.fake ? (0, $af64f50f3d11d5e1$export$81b27fa331809b9b)(body, docOverflow) : div.remove();
    return result;
}


// get subpixel support value
// @return - boolean



function $427f5d1737b400d1$export$7b334bfa4e585549() {
    // check subpixel layout supporting
    var doc = document, body = (0, $b7572e32da8ee13a$export$135b49d4bc2964c6)(), docOverflow = (0, $58ed177cc807d047$export$4078b67b5eba0c5)(body), wrapper = doc.createElement("div"), outer = doc.createElement("div"), str = "", count = 70, perPage = 3, supported = false;
    wrapper.className = "tns-t-subp2";
    outer.className = "tns-t-ct";
    for(var i = 0; i < count; i++)str += "<div></div>";
    outer.innerHTML = str;
    wrapper.appendChild(outer);
    body.appendChild(wrapper);
    supported = Math.abs(wrapper.getBoundingClientRect().left - outer.children[count - perPage].getBoundingClientRect().left) < 2;
    body.fake ? (0, $af64f50f3d11d5e1$export$81b27fa331809b9b)(body, docOverflow) : wrapper.remove();
    return supported;
}





function $3520b2cd5f778f00$export$48976c233ddfebe2() {
    if (window.matchMedia || window.msMatchMedia) return true;
    var doc = document, body = (0, $b7572e32da8ee13a$export$135b49d4bc2964c6)(), docOverflow = (0, $58ed177cc807d047$export$4078b67b5eba0c5)(body), div = doc.createElement("div"), style = doc.createElement("style"), rule = "@media all and (min-width:1px){.tns-mq-test{position:absolute}}", position;
    style.type = "text/css";
    div.className = "tns-mq-test";
    body.appendChild(style);
    body.appendChild(div);
    if (style.styleSheet) style.styleSheet.cssText = rule;
    else style.appendChild(doc.createTextNode(rule));
    position = window.getComputedStyle ? window.getComputedStyle(div).position : div.currentStyle["position"];
    body.fake ? (0, $af64f50f3d11d5e1$export$81b27fa331809b9b)(body, docOverflow) : div.remove();
    return position === "absolute";
}


// create and append style sheet
function $a694349ebc945c16$export$d07d6a5154e3b470(media, nonce) {
    // Create the <style> tag
    var style = document.createElement("style");
    // style.setAttribute("type", "text/css");
    // Add a media (and/or media query) here if you'd like!
    // style.setAttribute("media", "screen")
    // style.setAttribute("media", "only screen and (max-width : 1024px)")
    if (media) style.setAttribute("media", media);
    // Add nonce attribute for Content Security Policy
    if (nonce) style.setAttribute("nonce", nonce);
    // WebKit hack :(
    // style.appendChild(document.createTextNode(""));
    // Add the <style> element to the page
    document.querySelector("head").appendChild(style);
    return style.sheet ? style.sheet : style.styleSheet;
}


// cross browsers addRule method

function $1a90d19cf20fcd68$export$bf97e331026f75ba(sheet, selector, rules, index) {
    // return raf(function() {
    "insertRule" in sheet ? sheet.insertRule(selector + "{" + rules + "}", index) : sheet.addRule(selector, rules, index);
// });
}


// cross browsers addRule method

function $290e8f413288fb29$export$271e480b8a432c4a(sheet, index) {
    // return raf(function() {
    "deleteRule" in sheet ? sheet.deleteRule(index) : sheet.removeRule(index);
// });
}


function $97bce8d8c89c4190$export$ccd7e907f4f59892(sheet) {
    var rule = "insertRule" in sheet ? sheet.cssRules : sheet.rules;
    return rule.length;
}


function $d546b5ddaa1f720a$export$c796d9d3e501591f(y, x) {
    return Math.atan2(y, x) * (180 / Math.PI);
}


function $c56a54e7f265475e$export$83b6d73568c72b60(angle, range) {
    var direction = false, gap = Math.abs(90 - Math.abs(angle));
    if (gap >= 90 - range) direction = "horizontal";
    else if (gap <= range) direction = "vertical";
    return direction;
}


// https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/
function $c4d187697d100d42$export$4b80e395e36b5a56(arr, callback, scope) {
    for(var i = 0, l = arr.length; i < l; i++)callback.call(scope, arr[i], i);
}


var $51f4ed50b4a4690f$export$8b753db5fc454027 = "classList" in document.createElement("_");


var $e4fd7ed3fd7a85e9$export$4ea3d958472af68f = (0, $51f4ed50b4a4690f$export$8b753db5fc454027) ? function hasClass(el, str) {
    return el.classList.contains(str);
} : function(el, str) {
    return el.className.indexOf(str) >= 0;
};



var $58aedeabc9b57e85$export$d2cf6cd1dc7067d3 = (0, $51f4ed50b4a4690f$export$8b753db5fc454027) ? function addClass(el, str) {
    if (!(0, $e4fd7ed3fd7a85e9$export$4ea3d958472af68f)(el, str)) el.classList.add(str);
} : function(el, str) {
    if (!(0, $e4fd7ed3fd7a85e9$export$4ea3d958472af68f)(el, str)) el.className += " " + str;
};



var $91ec85d1e7d05de6$export$c2255604a80b4506 = (0, $51f4ed50b4a4690f$export$8b753db5fc454027) ? function removeClass(el, str) {
    if ((0, $e4fd7ed3fd7a85e9$export$4ea3d958472af68f)(el, str)) el.classList.remove(str);
} : function(el, str) {
    if ((0, $e4fd7ed3fd7a85e9$export$4ea3d958472af68f)(el, str)) el.className = el.className.replace(str, "");
};


function $92c19f95ffd892da$export$5608640b1bf2f6d7(el, attr) {
    return el.hasAttribute(attr);
}


function $36eae2ea1433e2ee$export$6a93fe6b2b4c71a0(el, attr) {
    return el.getAttribute(attr);
}


function $938c4d79fdcca292$export$ff45fc08c57bb9d0(el) {
    // Only NodeList has the "item()" function
    return typeof el.item !== "undefined";
}


function $fc4786701fd188a9$export$7e45664a2081efb1(els, attrs) {
    els = (0, $938c4d79fdcca292$export$ff45fc08c57bb9d0)(els) || els instanceof Array ? els : [
        els
    ];
    if (Object.prototype.toString.call(attrs) !== "[object Object]") return;
    for(var i = els.length; i--;)for(var key in attrs)els[i].setAttribute(key, attrs[key]);
}



function $374312ce9bdfbef2$export$711225beb0f1ef57(els, attrs) {
    els = (0, $938c4d79fdcca292$export$ff45fc08c57bb9d0)(els) || els instanceof Array ? els : [
        els
    ];
    attrs = attrs instanceof Array ? attrs : [
        attrs
    ];
    var attrLength = attrs.length;
    for(var i = els.length; i--;)for(var j = attrLength; j--;)els[i].removeAttribute(attrs[j]);
}


function $e10011047bee640d$export$19b645cc08e75c7c(nl) {
    var arr = [];
    for(var i = 0, l = nl.length; i < l; i++)arr.push(nl[i]);
    return arr;
}


function $b6b059ab1be1bedb$export$7669482c90f5c50f(el, forceHide) {
    if (el.style.display !== "none") el.style.display = "none";
}


function $7e4aafbbd7b5f772$export$998191bfdf710c72(el, forceHide) {
    if (el.style.display === "none") el.style.display = "";
}


function $807f43eecb4b0d07$export$795910f5f15a9633(el) {
    return window.getComputedStyle(el).display !== "none";
}


function $d4329b30388a7ff3$export$d7ea39ebd37f24a6(props) {
    if (typeof props === "string") {
        var arr = [
            props
        ], Props = props.charAt(0).toUpperCase() + props.substr(1), prefixes = [
            "Webkit",
            "Moz",
            "ms",
            "O"
        ];
        prefixes.forEach(function(prefix) {
            if (prefix !== "ms" || props === "transform") arr.push(prefix + Props);
        });
        props = arr;
    }
    var el = document.createElement("fakeelement"), len = props.length;
    for(var i = 0; i < props.length; i++){
        var prop = props[i];
        if (el.style[prop] !== undefined) return prop;
    }
    return false; // explicit for ie9-
}





function $ecedc1b76fb35f4f$export$c0585cbcaae92b06(tf) {
    if (!tf) return false;
    if (!window.getComputedStyle) return false;
    var doc = document, body = (0, $b7572e32da8ee13a$export$135b49d4bc2964c6)(), docOverflow = (0, $58ed177cc807d047$export$4078b67b5eba0c5)(body), el = doc.createElement("p"), has3d, cssTF = tf.length > 9 ? "-" + tf.slice(0, -9).toLowerCase() + "-" : "";
    cssTF += "transform";
    // Add it to the body to get the computed style
    body.insertBefore(el, null);
    el.style[tf] = "translate3d(1px,1px,1px)";
    has3d = window.getComputedStyle(el).getPropertyValue(cssTF);
    body.fake ? (0, $af64f50f3d11d5e1$export$81b27fa331809b9b)(body, docOverflow) : el.remove();
    return has3d !== undefined && has3d.length > 0 && has3d !== "none";
}


// get transitionend, animationend based on transitionDuration
// @propin: string
// @propOut: string, first-letter uppercase
// Usage: getEndProperty('WebkitTransitionDuration', 'Transition') => webkitTransitionEnd
function $0b7f95712488e6e9$export$41e71ffeacbff65e(propIn, propOut) {
    var endProp = false;
    if (/^Webkit/.test(propIn)) endProp = "webkit" + propOut + "End";
    else if (/^O/.test(propIn)) endProp = "o" + propOut + "End";
    else if (propIn) endProp = propOut.toLowerCase() + "end";
    return endProp;
}


// Test via a getter in the options object to see if the passive property is accessed
var $6deed872f0ad204e$var$supportsPassive = false;
try {
    var $6deed872f0ad204e$var$opts = Object.defineProperty({}, "passive", {
        get: function get() {
            $6deed872f0ad204e$var$supportsPassive = true;
        }
    });
    window.addEventListener("test", null, $6deed872f0ad204e$var$opts);
} catch (e) {}
var $6deed872f0ad204e$export$555390bf67cc3262 = $6deed872f0ad204e$var$supportsPassive ? {
    passive: true
} : false;


function $2d450f9a54805e30$export$aadfb65bee660f96(el, obj, preventScrolling) {
    for(var prop in obj){
        var option = [
            "touchstart",
            "touchmove"
        ].indexOf(prop) >= 0 && !preventScrolling ? (0, $6deed872f0ad204e$export$555390bf67cc3262) : false;
        el.addEventListener(prop, obj[prop], option);
    }
}



function $d58278b019a227a5$export$da5f6eb3bb522cd(el, obj) {
    for(var prop in obj){
        var option = [
            "touchstart",
            "touchmove"
        ].indexOf(prop) >= 0 ? (0, $6deed872f0ad204e$export$555390bf67cc3262) : false;
        el.removeEventListener(prop, obj[prop], option);
    }
}


function $7eff8d4ddf1a4c34$export$ada873a34909da65() {
    return {
        topics: {},
        on: function on(eventName, fn) {
            this.topics[eventName] = this.topics[eventName] || [];
            this.topics[eventName].push(fn);
        },
        off: function off(eventName, fn) {
            if (this.topics[eventName]) {
                for(var i = 0; i < this.topics[eventName].length; i++)if (this.topics[eventName][i] === fn) {
                    this.topics[eventName].splice(i, 1);
                    break;
                }
            }
        },
        emit: function emit(eventName, data) {
            data.type = eventName;
            if (this.topics[eventName]) this.topics[eventName].forEach(function(fn) {
                fn(data, eventName);
            });
        }
    };
}


function $9e1eeb371de7034f$export$e2705a83c013f564(element, attr, prefix, postfix, to, duration, callback) {
    var tick = Math.min(duration, 10), unit = to.indexOf("%") >= 0 ? "%" : "px", to = to.replace(unit, ""), from = Number(element.style[attr].replace(prefix, "").replace(postfix, "").replace(unit, "")), positionTick = (to - from) / duration * tick, running;
    setTimeout(moveElement, tick);
    function moveElement() {
        duration -= tick;
        from += positionTick;
        element.style[attr] = prefix + from + unit + postfix;
        if (duration > 0) setTimeout(moveElement, tick);
        else callback();
    }
}


if (!Object.keys) Object.keys = function(object) {
    var keys = [];
    for(var name in object)if (Object.prototype.hasOwnProperty.call(object, name)) keys.push(name);
    return keys;
};
// ChildNode.remove
if (!("remove" in Element.prototype)) Element.prototype.remove = function() {
    if (this.parentNode) this.parentNode.removeChild(this);
};
var $665047dee130590c$export$51fe319e24d9d8c9 = function tns1(options) {
    options = (0, $8def800bd2c631ba$export$8b58be045bf06082)({
        container: ".slider",
        mode: "carousel",
        axis: "horizontal",
        items: 1,
        gutter: 0,
        edgePadding: 0,
        fixedWidth: false,
        autoWidth: false,
        viewportMax: false,
        slideBy: 1,
        center: false,
        controls: true,
        controlsPosition: "top",
        controlsText: [
            "prev",
            "next"
        ],
        controlsContainer: false,
        prevButton: false,
        nextButton: false,
        nav: true,
        navPosition: "top",
        navContainer: false,
        navAsThumbnails: false,
        arrowKeys: false,
        speed: 300,
        autoplay: false,
        autoplayPosition: "top",
        autoplayTimeout: 5000,
        autoplayDirection: "forward",
        autoplayText: [
            "start",
            "stop"
        ],
        autoplayHoverPause: false,
        autoplayButton: false,
        autoplayButtonOutput: true,
        autoplayResetOnVisibility: true,
        animateIn: "tns-fadeIn",
        animateOut: "tns-fadeOut",
        animateNormal: "tns-normal",
        animateDelay: false,
        loop: true,
        rewind: false,
        autoHeight: false,
        responsive: false,
        lazyload: false,
        lazyloadSelector: ".tns-lazy-img",
        touch: true,
        mouseDrag: false,
        swipeAngle: 15,
        nested: false,
        preventActionWhenRunning: false,
        preventScrollOnTouch: false,
        freezable: true,
        onInit: false,
        useLocalStorage: true,
        nonce: false
    }, options || {});
    var doc = document, win = window, KEYS = {
        ENTER: 13,
        SPACE: 32,
        LEFT: 37,
        RIGHT: 39
    }, tnsStorage = {}, localStorageAccess = options.useLocalStorage;
    if (localStorageAccess) {
        // check browser version and local storage access
        var browserInfo = navigator.userAgent;
        var uid = new Date;
        try {
            tnsStorage = win.localStorage;
            if (tnsStorage) {
                tnsStorage.setItem(uid, uid);
                localStorageAccess = tnsStorage.getItem(uid) == uid;
                tnsStorage.removeItem(uid);
            } else localStorageAccess = false;
            if (!localStorageAccess) tnsStorage = {};
        } catch (e) {
            localStorageAccess = false;
        }
        if (localStorageAccess) {
            // remove storage when browser version changes
            if (tnsStorage["tnsApp"] && tnsStorage["tnsApp"] !== browserInfo) [
                "tC",
                "tPL",
                "tMQ",
                "tTf",
                "t3D",
                "tTDu",
                "tTDe",
                "tADu",
                "tADe",
                "tTE",
                "tAE"
            ].forEach(function(item) {
                tnsStorage.removeItem(item);
            });
            // update browserInfo
            localStorage["tnsApp"] = browserInfo;
        }
    }
    var CALC = tnsStorage["tC"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tC"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tC", (0, $155687d682cfd223$export$42bfa9b2d4dad91a)(), localStorageAccess), PERCENTAGELAYOUT = tnsStorage["tPL"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tPL"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tPL", (0, $427f5d1737b400d1$export$7b334bfa4e585549)(), localStorageAccess), CSSMQ = tnsStorage["tMQ"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tMQ"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tMQ", (0, $3520b2cd5f778f00$export$48976c233ddfebe2)(), localStorageAccess), TRANSFORM = tnsStorage["tTf"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tTf"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tTf", (0, $d4329b30388a7ff3$export$d7ea39ebd37f24a6)("transform"), localStorageAccess), HAS3DTRANSFORMS = tnsStorage["t3D"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["t3D"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "t3D", (0, $ecedc1b76fb35f4f$export$c0585cbcaae92b06)(TRANSFORM), localStorageAccess), TRANSITIONDURATION = tnsStorage["tTDu"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tTDu"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tTDu", (0, $d4329b30388a7ff3$export$d7ea39ebd37f24a6)("transitionDuration"), localStorageAccess), TRANSITIONDELAY = tnsStorage["tTDe"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tTDe"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tTDe", (0, $d4329b30388a7ff3$export$d7ea39ebd37f24a6)("transitionDelay"), localStorageAccess), ANIMATIONDURATION = tnsStorage["tADu"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tADu"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tADu", (0, $d4329b30388a7ff3$export$d7ea39ebd37f24a6)("animationDuration"), localStorageAccess), ANIMATIONDELAY = tnsStorage["tADe"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tADe"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tADe", (0, $d4329b30388a7ff3$export$d7ea39ebd37f24a6)("animationDelay"), localStorageAccess), TRANSITIONEND = tnsStorage["tTE"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tTE"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tTE", (0, $0b7f95712488e6e9$export$41e71ffeacbff65e)(TRANSITIONDURATION, "Transition"), localStorageAccess), ANIMATIONEND = tnsStorage["tAE"] ? (0, $35e19be817102b97$export$79d1167a24e4e930)(tnsStorage["tAE"]) : (0, $2033929a7fec2873$export$1f73f60bdb811cb1)(tnsStorage, "tAE", (0, $0b7f95712488e6e9$export$41e71ffeacbff65e)(ANIMATIONDURATION, "Animation"), localStorageAccess);
    // get element nodes from selectors
    var supportConsoleWarn = win.console && typeof win.console.warn === "function", tnsList = [
        "container",
        "controlsContainer",
        "prevButton",
        "nextButton",
        "navContainer",
        "autoplayButton"
    ], optionsElements = {};
    tnsList.forEach(function(item) {
        if (typeof options[item] === "string") {
            var str = options[item], el = doc.querySelector(str);
            optionsElements[item] = str;
            if (el && el.nodeName) options[item] = el;
            else {
                if (supportConsoleWarn) console.warn("Can't find", options[item]);
                return;
            }
        }
    });
    // make sure at least 1 slide
    if (options.container.children.length < 1) {
        if (supportConsoleWarn) console.warn("No slides found in", options.container);
        return;
    }
    // update options
    var responsive = options.responsive, nested = options.nested, carousel = options.mode === "carousel" ? true : false;
    if (responsive) {
        // apply responsive[0] to options and remove it
        if (0 in responsive) {
            options = (0, $8def800bd2c631ba$export$8b58be045bf06082)(options, responsive[0]);
            delete responsive[0];
        }
        var responsiveTem = {};
        for(var key in responsive){
            var val = responsive[key];
            // update responsive
            // from: 300: 2
            // to:
            //   300: {
            //     items: 2
            //   }
            val = typeof val === "number" ? {
                items: val
            } : val;
            responsiveTem[key] = val;
        }
        responsive = responsiveTem;
        responsiveTem = null;
    }
    // update options
    function updateOptions(obj) {
        for(var key in obj){
            if (!carousel) {
                if (key === "slideBy") obj[key] = "page";
                if (key === "edgePadding") obj[key] = false;
                if (key === "autoHeight") obj[key] = false;
            }
            // update responsive options
            if (key === "responsive") updateOptions(obj[key]);
        }
    }
    if (!carousel) updateOptions(options);
    // === define and set variables ===
    if (!carousel) {
        options.axis = "horizontal";
        options.slideBy = "page";
        options.edgePadding = false;
        var animateIn = options.animateIn, animateOut = options.animateOut, animateDelay = options.animateDelay, animateNormal = options.animateNormal;
    }
    var horizontal = options.axis === "horizontal" ? true : false, outerWrapper = doc.createElement("div"), innerWrapper = doc.createElement("div"), middleWrapper, container = options.container, containerParent = container.parentNode, containerHTML = container.outerHTML, slideItems = container.children, slideCount = slideItems.length, breakpointZone, windowWidth = getWindowWidth(), isOn = false;
    if (responsive) setBreakpointZone();
    if (carousel) container.className += " tns-vpfix";
    // fixedWidth: viewport > rightBoundary > indexMax
    var autoWidth = options.autoWidth, fixedWidth = getOption("fixedWidth"), edgePadding = getOption("edgePadding"), gutter = getOption("gutter"), viewport = getViewportWidth(), center = getOption("center"), items = !autoWidth ? Math.floor(getOption("items")) : 1, slideBy = getOption("slideBy"), viewportMax = options.viewportMax || options.fixedWidthViewportWidth, arrowKeys = getOption("arrowKeys"), speed = getOption("speed"), rewind = options.rewind, loop = rewind ? false : options.loop, autoHeight = getOption("autoHeight"), controls = getOption("controls"), controlsText = getOption("controlsText"), nav = getOption("nav"), touch = getOption("touch"), mouseDrag = getOption("mouseDrag"), autoplay = getOption("autoplay"), autoplayTimeout = getOption("autoplayTimeout"), autoplayText = getOption("autoplayText"), autoplayHoverPause = getOption("autoplayHoverPause"), autoplayResetOnVisibility = getOption("autoplayResetOnVisibility"), sheet = (0, $a694349ebc945c16$export$d07d6a5154e3b470)(null, getOption("nonce")), lazyload = options.lazyload, lazyloadSelector = options.lazyloadSelector, slidePositions, slideItemsOut = [], cloneCount = loop ? getCloneCountForLoop() : 0, slideCountNew = !carousel ? slideCount + cloneCount : slideCount + cloneCount * 2, hasRightDeadZone = (fixedWidth || autoWidth) && !loop ? true : false, rightBoundary = fixedWidth ? getRightBoundary() : null, updateIndexBeforeTransform = !carousel || !loop ? true : false, // transform
    transformAttr = horizontal ? "left" : "top", transformPrefix = "", transformPostfix = "", // index
    getIndexMax = function() {
        if (fixedWidth) return function() {
            return center && !loop ? slideCount - 1 : Math.ceil(-rightBoundary / (fixedWidth + gutter));
        };
        else if (autoWidth) return function() {
            for(var i = 0; i < slideCountNew; i++){
                if (slidePositions[i] >= -rightBoundary) return i;
            }
        };
        else return function() {
            if (center && carousel && !loop) return slideCount - 1;
            else return loop || carousel ? Math.max(0, slideCountNew - Math.ceil(items)) : slideCountNew - 1;
        };
    }(), index = getStartIndex(getOption("startIndex")), indexCached = index, displayIndex = getCurrentSlide(), indexMin = 0, indexMax = !autoWidth ? getIndexMax() : null, // resize
    resizeTimer, preventActionWhenRunning = options.preventActionWhenRunning, swipeAngle = options.swipeAngle, moveDirectionExpected = swipeAngle ? "?" : true, running = false, onInit = options.onInit, events = new (0, $7eff8d4ddf1a4c34$export$ada873a34909da65)(), // id, class
    newContainerClasses = " tns-slider tns-" + options.mode, slideId = container.id || (0, $d7f329ede83197d7$export$ff0ccbbb2d1923f6)(), disable = getOption("disable"), disabled = false, freezable = options.freezable, freeze = freezable && !autoWidth ? getFreeze() : false, frozen = false, controlsEvents = {
        "click": onControlsClick,
        "keydown": onControlsKeydown
    }, navEvents = {
        "click": onNavClick,
        "keydown": onNavKeydown
    }, hoverEvents = {
        "mouseover": mouseoverPause,
        "mouseout": mouseoutRestart
    }, visibilityEvent = {
        "visibilitychange": onVisibilityChange
    }, docmentKeydownEvent = {
        "keydown": onDocumentKeydown
    }, touchEvents = {
        "touchstart": onPanStart,
        "touchmove": onPanMove,
        "touchend": onPanEnd,
        "touchcancel": onPanEnd
    }, dragEvents = {
        "mousedown": onPanStart,
        "mousemove": onPanMove,
        "mouseup": onPanEnd,
        "mouseleave": onPanEnd
    }, hasControls = hasOption("controls"), hasNav = hasOption("nav"), navAsThumbnails = autoWidth ? true : options.navAsThumbnails, hasAutoplay = hasOption("autoplay"), hasTouch = hasOption("touch"), hasMouseDrag = hasOption("mouseDrag"), slideActiveClass = "tns-slide-active", slideClonedClass = "tns-slide-cloned", imgCompleteClass = "tns-complete", imgEvents = {
        "load": onImgLoaded,
        "error": onImgFailed
    }, imgsComplete, liveregionCurrent, preventScroll = options.preventScrollOnTouch === "force" ? true : false;
    // controls
    if (hasControls) var controlsContainer = options.controlsContainer, controlsContainerHTML = options.controlsContainer ? options.controlsContainer.outerHTML : "", prevButton = options.prevButton, nextButton = options.nextButton, prevButtonHTML = options.prevButton ? options.prevButton.outerHTML : "", nextButtonHTML = options.nextButton ? options.nextButton.outerHTML : "", prevIsButton, nextIsButton;
    // nav
    if (hasNav) var navContainer = options.navContainer, navContainerHTML = options.navContainer ? options.navContainer.outerHTML : "", navItems, pages = autoWidth ? slideCount : getPages(), pagesCached = 0, navClicked = -1, navCurrentIndex = getCurrentNavIndex(), navCurrentIndexCached = navCurrentIndex, navActiveClass = "tns-nav-active", navStr = "Carousel Page ", navStrCurrent = " (Current Slide)";
    // autoplay
    if (hasAutoplay) var autoplayDirection = options.autoplayDirection === "forward" ? 1 : -1, autoplayButton = options.autoplayButton, autoplayButtonHTML = options.autoplayButton ? options.autoplayButton.outerHTML : "", autoplayHtmlStrings = [
        "<span class='tns-visually-hidden'>",
        " animation</span>"
    ], autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused;
    if (hasTouch || hasMouseDrag) var initPosition = {}, lastPosition = {}, translateInit, disX, disY, panStart = false, rafIndex, getDist = horizontal ? function getDist(a, b) {
        return a.x - b.x;
    } : function(a, b) {
        return a.y - b.y;
    };
    // disable slider when slidecount <= items
    if (!autoWidth) resetVariblesWhenDisable(disable || freeze);
    if (TRANSFORM) {
        transformAttr = TRANSFORM;
        transformPrefix = "translate";
        if (HAS3DTRANSFORMS) {
            transformPrefix += horizontal ? "3d(" : "3d(0px, ";
            transformPostfix = horizontal ? ", 0px, 0px)" : ", 0px)";
        } else {
            transformPrefix += horizontal ? "X(" : "Y(";
            transformPostfix = ")";
        }
    }
    if (carousel) container.className = container.className.replace("tns-vpfix", "");
    initStructure();
    initSheet();
    initSliderTransform();
    // === COMMON FUNCTIONS === //
    function resetVariblesWhenDisable(condition) {
        if (condition) controls = nav = touch = mouseDrag = arrowKeys = autoplay = autoplayHoverPause = autoplayResetOnVisibility = false;
    }
    function getCurrentSlide() {
        var tem = carousel ? index - cloneCount : index;
        while(tem < 0)tem += slideCount;
        return tem % slideCount + 1;
    }
    function getStartIndex(ind) {
        ind = ind ? Math.max(0, Math.min(loop ? slideCount - 1 : slideCount - items, ind)) : 0;
        return carousel ? ind + cloneCount : ind;
    }
    function getAbsIndex(i) {
        if (i == null) i = index;
        if (carousel) i -= cloneCount;
        while(i < 0)i += slideCount;
        return Math.floor(i % slideCount);
    }
    function getCurrentNavIndex() {
        var absIndex = getAbsIndex(), result;
        result = navAsThumbnails ? absIndex : fixedWidth || autoWidth ? Math.ceil((absIndex + 1) * pages / slideCount - 1) : Math.floor(absIndex / items);
        // set active nav to the last one when reaches the right edge
        if (!loop && carousel && index === indexMax) result = pages - 1;
        return result;
    }
    function getItemsMax() {
        // fixedWidth or autoWidth while viewportMax is not available
        if (autoWidth || fixedWidth && !viewportMax) return slideCount - 1;
        else {
            var str = fixedWidth ? "fixedWidth" : "items", arr = [];
            if (fixedWidth || options[str] < slideCount) arr.push(options[str]);
            if (responsive) for(var bp in responsive){
                var tem = responsive[bp][str];
                if (tem && (fixedWidth || tem < slideCount)) arr.push(tem);
            }
            if (!arr.length) arr.push(0);
            return Math.ceil(fixedWidth ? viewportMax / Math.min.apply(null, arr) : Math.max.apply(null, arr));
        }
    }
    function getCloneCountForLoop() {
        var itemsMax = getItemsMax(), result = carousel ? Math.ceil((itemsMax * 5 - slideCount) / 2) : itemsMax * 4 - slideCount;
        result = Math.max(itemsMax, result);
        return hasOption("edgePadding") ? result + 1 : result;
    }
    function getWindowWidth() {
        return win.innerWidth || doc.documentElement.clientWidth || doc.body.clientWidth;
    }
    function getInsertPosition(pos) {
        return pos === "top" ? "afterbegin" : "beforeend";
    }
    function getClientWidth(el) {
        if (el == null) return;
        var div = doc.createElement("div"), rect, width;
        el.appendChild(div);
        rect = div.getBoundingClientRect();
        width = rect.right - rect.left;
        div.remove();
        return width || getClientWidth(el.parentNode);
    }
    function getViewportWidth() {
        var gap = edgePadding ? edgePadding * 2 - gutter : 0;
        return getClientWidth(containerParent) - gap;
    }
    function hasOption(item) {
        if (options[item]) return true;
        else {
            if (responsive) for(var bp in responsive){
                if (responsive[bp][item]) return true;
            }
            return false;
        }
    }
    // get option:
    // fixed width: viewport, fixedWidth, gutter => items
    // others: window width => all variables
    // all: items => slideBy
    function getOption(item, ww) {
        if (ww == null) ww = windowWidth;
        if (item === "items" && fixedWidth) return Math.floor((viewport + gutter) / (fixedWidth + gutter)) || 1;
        else {
            var result = options[item];
            if (responsive) for(var bp in responsive){
                // bp: convert string to number
                if (ww >= parseInt(bp)) {
                    if (item in responsive[bp]) result = responsive[bp][item];
                }
            }
            if (item === "slideBy" && result === "page") result = getOption("items");
            if (!carousel && (item === "slideBy" || item === "items")) result = Math.floor(result);
            return result;
        }
    }
    function getSlideMarginLeft(i) {
        return CALC ? CALC + "(" + i * 100 + "% / " + slideCountNew + ")" : i * 100 / slideCountNew + "%";
    }
    function getInnerWrapperStyles(edgePaddingTem, gutterTem, fixedWidthTem, speedTem, autoHeightBP) {
        var str = "";
        if (edgePaddingTem !== undefined) {
            var gap = edgePaddingTem;
            if (gutterTem) gap -= gutterTem;
            str = horizontal ? "margin: 0 " + gap + "px 0 " + edgePaddingTem + "px;" : "margin: " + edgePaddingTem + "px 0 " + gap + "px 0;";
        } else if (gutterTem && !fixedWidthTem) {
            var gutterTemUnit = "-" + gutterTem + "px", dir = horizontal ? gutterTemUnit + " 0 0" : "0 " + gutterTemUnit + " 0";
            str = "margin: 0 " + dir + ";";
        }
        if (!carousel && autoHeightBP && TRANSITIONDURATION && speedTem) str += getTransitionDurationStyle(speedTem);
        return str;
    }
    function getContainerWidth(fixedWidthTem, gutterTem, itemsTem) {
        if (fixedWidthTem) return (fixedWidthTem + gutterTem) * slideCountNew + "px";
        else return CALC ? CALC + "(" + slideCountNew * 100 + "% / " + itemsTem + ")" : slideCountNew * 100 / itemsTem + "%";
    }
    function getSlideWidthStyle(fixedWidthTem, gutterTem, itemsTem) {
        var width;
        if (fixedWidthTem) width = fixedWidthTem + gutterTem + "px";
        else {
            if (!carousel) itemsTem = Math.floor(itemsTem);
            var dividend = carousel ? slideCountNew : itemsTem;
            width = CALC ? CALC + "(100% / " + dividend + ")" : 100 / dividend + "%";
        }
        width = "width:" + width;
        // inner slider: overwrite outer slider styles
        return nested !== "inner" ? width + ";" : width + " !important;";
    }
    function getSlideGutterStyle(gutterTem) {
        var str = "";
        // gutter maybe interger || 0
        // so can't use 'if (gutter)'
        if (gutterTem !== false) {
            var prop = horizontal ? "padding-" : "margin-", dir = horizontal ? "right" : "bottom";
            str = prop + dir + ": " + gutterTem + "px;";
        }
        return str;
    }
    function getCSSPrefix(name, num) {
        var prefix = name.substring(0, name.length - num).toLowerCase();
        if (prefix) prefix = "-" + prefix + "-";
        return prefix;
    }
    function getTransitionDurationStyle(speed) {
        return getCSSPrefix(TRANSITIONDURATION, 18) + "transition-duration:" + speed / 1000 + "s;";
    }
    function getAnimationDurationStyle(speed) {
        return getCSSPrefix(ANIMATIONDURATION, 17) + "animation-duration:" + speed / 1000 + "s;";
    }
    function initStructure() {
        var classOuter = "tns-outer", classInner = "tns-inner", hasGutter = hasOption("gutter");
        outerWrapper.className = classOuter;
        innerWrapper.className = classInner;
        outerWrapper.id = slideId + "-ow";
        innerWrapper.id = slideId + "-iw";
        // set container properties
        if (container.id === "") container.id = slideId;
        newContainerClasses += PERCENTAGELAYOUT || autoWidth ? " tns-subpixel" : " tns-no-subpixel";
        newContainerClasses += CALC ? " tns-calc" : " tns-no-calc";
        if (autoWidth) newContainerClasses += " tns-autowidth";
        newContainerClasses += " tns-" + options.axis;
        container.className += newContainerClasses;
        // add constrain layer for carousel
        if (carousel) {
            middleWrapper = doc.createElement("div");
            middleWrapper.id = slideId + "-mw";
            middleWrapper.className = "tns-ovh";
            outerWrapper.appendChild(middleWrapper);
            middleWrapper.appendChild(innerWrapper);
        } else outerWrapper.appendChild(innerWrapper);
        if (autoHeight) {
            var wp = middleWrapper ? middleWrapper : innerWrapper;
            wp.className += " tns-ah";
        }
        containerParent.insertBefore(outerWrapper, container);
        innerWrapper.appendChild(container);
        // add id, class, aria attributes
        // before clone slides
        (0, $c4d187697d100d42$export$4b80e395e36b5a56)(slideItems, function(item, i) {
            (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, "tns-item");
            if (!item.id) item.id = slideId + "-item" + i;
            if (!carousel && animateNormal) (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, animateNormal);
            (0, $fc4786701fd188a9$export$7e45664a2081efb1)(item, {
                "aria-hidden": "true",
                "tabindex": "-1"
            });
        });
        // ## clone slides
        // carousel: n + slides + n
        // gallery:      slides + n
        if (cloneCount) {
            var fragmentBefore = doc.createDocumentFragment(), fragmentAfter = doc.createDocumentFragment();
            for(var j = cloneCount; j--;){
                var num = j % slideCount, cloneFirst = slideItems[num].cloneNode(true);
                (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(cloneFirst, slideClonedClass);
                (0, $374312ce9bdfbef2$export$711225beb0f1ef57)(cloneFirst, "id");
                fragmentAfter.insertBefore(cloneFirst, fragmentAfter.firstChild);
                if (carousel) {
                    var cloneLast = slideItems[slideCount - 1 - num].cloneNode(true);
                    (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(cloneLast, slideClonedClass);
                    (0, $374312ce9bdfbef2$export$711225beb0f1ef57)(cloneLast, "id");
                    fragmentBefore.appendChild(cloneLast);
                }
            }
            container.insertBefore(fragmentBefore, container.firstChild);
            container.appendChild(fragmentAfter);
            slideItems = container.children;
        }
    }
    function initSliderTransform() {
        // ## images loaded/failed
        if (hasOption("autoHeight") || autoWidth || !horizontal) {
            var imgs = container.querySelectorAll("img");
            // add img load event listener
            (0, $c4d187697d100d42$export$4b80e395e36b5a56)(imgs, function(img) {
                var src = img.src;
                if (!lazyload) {
                    // not data img
                    if (src && src.indexOf("data:image") < 0) {
                        img.src = "";
                        (0, $2d450f9a54805e30$export$aadfb65bee660f96)(img, imgEvents);
                        (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(img, "loading");
                        img.src = src;
                    // data img
                    } else imgLoaded(img);
                }
            });
            // set imgsComplete
            (0, $841e85ee868dd0d4$export$27f233d61a9e2fa4)(function() {
                imgsLoadedCheck((0, $e10011047bee640d$export$19b645cc08e75c7c)(imgs), function() {
                    imgsComplete = true;
                });
            });
            // reset imgs for auto height: check visible imgs only
            if (hasOption("autoHeight")) imgs = getImageArray(index, Math.min(index + items - 1, slideCountNew - 1));
            lazyload ? initSliderTransformStyleCheck() : (0, $841e85ee868dd0d4$export$27f233d61a9e2fa4)(function() {
                imgsLoadedCheck((0, $e10011047bee640d$export$19b645cc08e75c7c)(imgs), initSliderTransformStyleCheck);
            });
        } else {
            // set container transform property
            if (carousel) doContainerTransformSilent();
            // update slider tools and events
            initTools();
            initEvents();
        }
    }
    function initSliderTransformStyleCheck() {
        if (autoWidth && slideCount > 1) {
            // check styles application
            var num = loop ? index : slideCount - 1;
            (function stylesApplicationCheck() {
                var left = slideItems[num].getBoundingClientRect().left;
                var right = slideItems[num - 1].getBoundingClientRect().right;
                Math.abs(left - right) <= 1 ? initSliderTransformCore() : setTimeout(function() {
                    stylesApplicationCheck();
                }, 16);
            })();
        } else initSliderTransformCore();
    }
    function initSliderTransformCore() {
        // run Fn()s which are rely on image loading
        if (!horizontal || autoWidth) {
            setSlidePositions();
            if (autoWidth) {
                rightBoundary = getRightBoundary();
                if (freezable) freeze = getFreeze();
                indexMax = getIndexMax(); // <= slidePositions, rightBoundary <=
                resetVariblesWhenDisable(disable || freeze);
            } else updateContentWrapperHeight();
        }
        // set container transform property
        if (carousel) doContainerTransformSilent();
        // update slider tools and events
        initTools();
        initEvents();
    }
    function initSheet() {
        // gallery:
        // set animation classes and left value for gallery slider
        if (!carousel) for(var i = index, l = index + Math.min(slideCount, items); i < l; i++){
            var item = slideItems[i];
            item.style.left = (i - index) * 100 / items + "%";
            (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, animateIn);
            (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, animateNormal);
        }
        // #### LAYOUT
        // ## INLINE-BLOCK VS FLOAT
        // ## PercentageLayout:
        // slides: inline-block
        // remove blank space between slides by set font-size: 0
        // ## Non PercentageLayout:
        // slides: float
        //         margin-right: -100%
        //         margin-left: ~
        // Resource: https://docs.google.com/spreadsheets/d/147up245wwTXeQYve3BRSAD4oVcvQmuGsFteJOeA5xNQ/edit?usp=sharing
        if (horizontal) {
            if (PERCENTAGELAYOUT || autoWidth) {
                (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "#" + slideId + " > .tns-item", "font-size:" + win.getComputedStyle(slideItems[0]).fontSize + ";", (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
                (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "#" + slideId, "font-size:0;", (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
            } else if (carousel) (0, $c4d187697d100d42$export$4b80e395e36b5a56)(slideItems, function(slide, i) {
                slide.style.marginLeft = getSlideMarginLeft(i);
            });
        }
        // ## BASIC STYLES
        if (CSSMQ) {
            // middle wrapper style
            if (TRANSITIONDURATION) {
                var str = middleWrapper && options.autoHeight ? getTransitionDurationStyle(options.speed) : "";
                (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "#" + slideId + "-mw", str, (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
            }
            // inner wrapper styles
            str = getInnerWrapperStyles(options.edgePadding, options.gutter, options.fixedWidth, options.speed, options.autoHeight);
            (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "#" + slideId + "-iw", str, (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
            // container styles
            if (carousel) {
                str = horizontal && !autoWidth ? "width:" + getContainerWidth(options.fixedWidth, options.gutter, options.items) + ";" : "";
                if (TRANSITIONDURATION) str += getTransitionDurationStyle(speed);
                (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "#" + slideId, str, (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
            }
            // slide styles
            str = horizontal && !autoWidth ? getSlideWidthStyle(options.fixedWidth, options.gutter, options.items) : "";
            if (options.gutter) str += getSlideGutterStyle(options.gutter);
            // set gallery items transition-duration
            if (!carousel) {
                if (TRANSITIONDURATION) str += getTransitionDurationStyle(speed);
                if (ANIMATIONDURATION) str += getAnimationDurationStyle(speed);
            }
            if (str) (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "#" + slideId + " > .tns-item", str, (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
        // non CSS mediaqueries: IE8
        // ## update inner wrapper, container, slides if needed
        // set inline styles for inner wrapper & container
        // insert stylesheet (one line) for slides only (since slides are many)
        } else {
            // middle wrapper styles
            update_carousel_transition_duration();
            // inner wrapper styles
            innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, autoHeight);
            // container styles
            if (carousel && horizontal && !autoWidth) container.style.width = getContainerWidth(fixedWidth, gutter, items);
            // slide styles
            var str = horizontal && !autoWidth ? getSlideWidthStyle(fixedWidth, gutter, items) : "";
            if (gutter) str += getSlideGutterStyle(gutter);
            // append to the last line
            if (str) (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "#" + slideId + " > .tns-item", str, (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
        }
        // ## MEDIAQUERIES
        if (responsive && CSSMQ) for(var bp in responsive){
            // bp: convert string to number
            bp = parseInt(bp);
            var opts = responsive[bp], str = "", middleWrapperStr = "", innerWrapperStr = "", containerStr = "", slideStr = "", itemsBP = !autoWidth ? getOption("items", bp) : null, fixedWidthBP = getOption("fixedWidth", bp), speedBP = getOption("speed", bp), edgePaddingBP = getOption("edgePadding", bp), autoHeightBP = getOption("autoHeight", bp), gutterBP = getOption("gutter", bp);
            // middle wrapper string
            if (TRANSITIONDURATION && middleWrapper && getOption("autoHeight", bp) && "speed" in opts) middleWrapperStr = "#" + slideId + "-mw{" + getTransitionDurationStyle(speedBP) + "}";
            // inner wrapper string
            if ("edgePadding" in opts || "gutter" in opts) innerWrapperStr = "#" + slideId + "-iw{" + getInnerWrapperStyles(edgePaddingBP, gutterBP, fixedWidthBP, speedBP, autoHeightBP) + "}";
            // container string
            if (carousel && horizontal && !autoWidth && ("fixedWidth" in opts || "items" in opts || fixedWidth && "gutter" in opts)) containerStr = "width:" + getContainerWidth(fixedWidthBP, gutterBP, itemsBP) + ";";
            if (TRANSITIONDURATION && "speed" in opts) containerStr += getTransitionDurationStyle(speedBP);
            if (containerStr) containerStr = "#" + slideId + "{" + containerStr + "}";
            // slide string
            if ("fixedWidth" in opts || fixedWidth && "gutter" in opts || !carousel && "items" in opts) slideStr += getSlideWidthStyle(fixedWidthBP, gutterBP, itemsBP);
            if ("gutter" in opts) slideStr += getSlideGutterStyle(gutterBP);
            // set gallery items transition-duration
            if (!carousel && "speed" in opts) {
                if (TRANSITIONDURATION) slideStr += getTransitionDurationStyle(speedBP);
                if (ANIMATIONDURATION) slideStr += getAnimationDurationStyle(speedBP);
            }
            if (slideStr) slideStr = "#" + slideId + " > .tns-item{" + slideStr + "}";
            // add up
            str = middleWrapperStr + innerWrapperStr + containerStr + slideStr;
            if (str) sheet.insertRule("@media (min-width: " + bp / 16 + "em) {" + str + "}", sheet.cssRules.length);
        }
    }
    function initTools() {
        // == slides ==
        updateSlideStatus();
        // == live region ==
        outerWrapper.insertAdjacentHTML("afterbegin", '<div class="tns-liveregion tns-visually-hidden" aria-live="polite" aria-atomic="true">slide <span class="current">' + getLiveRegionStr() + "</span>  of " + slideCount + "</div>");
        liveregionCurrent = outerWrapper.querySelector(".tns-liveregion .current");
        // == autoplayInit ==
        if (hasAutoplay) {
            var txt = autoplay ? "stop" : "start";
            if (autoplayButton) (0, $fc4786701fd188a9$export$7e45664a2081efb1)(autoplayButton, {
                "data-action": txt
            });
            else if (options.autoplayButtonOutput) {
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.autoplayPosition), '<button type="button" data-action="' + txt + '">' + autoplayHtmlStrings[0] + txt + autoplayHtmlStrings[1] + autoplayText[0] + "</button>");
                autoplayButton = outerWrapper.querySelector("[data-action]");
            }
            // add event
            if (autoplayButton) (0, $2d450f9a54805e30$export$aadfb65bee660f96)(autoplayButton, {
                "click": toggleAutoplay
            });
            if (autoplay) {
                startAutoplay();
                if (autoplayHoverPause) (0, $2d450f9a54805e30$export$aadfb65bee660f96)(container, hoverEvents);
                if (autoplayResetOnVisibility) (0, $2d450f9a54805e30$export$aadfb65bee660f96)(container, visibilityEvent);
            }
        }
        // == navInit ==
        if (hasNav) {
            var initIndex = !carousel ? 0 : cloneCount;
            // customized nav
            // will not hide the navs in case they're thumbnails
            if (navContainer) {
                (0, $fc4786701fd188a9$export$7e45664a2081efb1)(navContainer, {
                    "aria-label": "Carousel Pagination"
                });
                navItems = navContainer.children;
                (0, $c4d187697d100d42$export$4b80e395e36b5a56)(navItems, function(item, i) {
                    (0, $fc4786701fd188a9$export$7e45664a2081efb1)(item, {
                        "data-nav": i,
                        "tabindex": "-1",
                        "aria-label": navStr + (i + 1),
                        "aria-controls": slideId
                    });
                });
            // generated nav
            } else {
                var navHtml = "", hiddenStr = navAsThumbnails ? "" : 'style="display:none"';
                for(var i = 0; i < slideCount; i++)// hide nav items by default
                navHtml += '<button type="button" data-nav="' + i + '" tabindex="-1" aria-controls="' + slideId + '" ' + hiddenStr + ' aria-label="' + navStr + (i + 1) + '"></button>';
                navHtml = '<div class="tns-nav" aria-label="Carousel Pagination">' + navHtml + "</div>";
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.navPosition), navHtml);
                navContainer = outerWrapper.querySelector(".tns-nav");
                navItems = navContainer.children;
            }
            updateNavVisibility();
            // add transition
            if (TRANSITIONDURATION) {
                var prefix = TRANSITIONDURATION.substring(0, TRANSITIONDURATION.length - 18).toLowerCase(), str = "transition: all " + speed / 1000 + "s";
                if (prefix) str = "-" + prefix + "-" + str;
                (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "[aria-controls^=" + slideId + "-item]", str, (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
            }
            (0, $fc4786701fd188a9$export$7e45664a2081efb1)(navItems[navCurrentIndex], {
                "aria-label": navStr + (navCurrentIndex + 1) + navStrCurrent
            });
            (0, $374312ce9bdfbef2$export$711225beb0f1ef57)(navItems[navCurrentIndex], "tabindex");
            (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(navItems[navCurrentIndex], navActiveClass);
            // add events
            (0, $2d450f9a54805e30$export$aadfb65bee660f96)(navContainer, navEvents);
        }
        // == controlsInit ==
        if (hasControls) {
            if (!controlsContainer && (!prevButton || !nextButton)) {
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.controlsPosition), '<div class="tns-controls" aria-label="Carousel Navigation" tabindex="0"><button type="button" data-controls="prev" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[0] + '</button><button type="button" data-controls="next" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[1] + "</button></div>");
                controlsContainer = outerWrapper.querySelector(".tns-controls");
            }
            if (!prevButton || !nextButton) {
                prevButton = controlsContainer.children[0];
                nextButton = controlsContainer.children[1];
            }
            if (options.controlsContainer) (0, $fc4786701fd188a9$export$7e45664a2081efb1)(controlsContainer, {
                "aria-label": "Carousel Navigation",
                "tabindex": "0"
            });
            if (options.controlsContainer || options.prevButton && options.nextButton) (0, $fc4786701fd188a9$export$7e45664a2081efb1)([
                prevButton,
                nextButton
            ], {
                "aria-controls": slideId,
                "tabindex": "-1"
            });
            if (options.controlsContainer || options.prevButton && options.nextButton) {
                (0, $fc4786701fd188a9$export$7e45664a2081efb1)(prevButton, {
                    "data-controls": "prev"
                });
                (0, $fc4786701fd188a9$export$7e45664a2081efb1)(nextButton, {
                    "data-controls": "next"
                });
            }
            prevIsButton = isButton(prevButton);
            nextIsButton = isButton(nextButton);
            updateControlsStatus();
            // add events
            if (controlsContainer) (0, $2d450f9a54805e30$export$aadfb65bee660f96)(controlsContainer, controlsEvents);
            else {
                (0, $2d450f9a54805e30$export$aadfb65bee660f96)(prevButton, controlsEvents);
                (0, $2d450f9a54805e30$export$aadfb65bee660f96)(nextButton, controlsEvents);
            }
        }
        // hide tools if needed
        disableUI();
    }
    function initEvents() {
        // add events
        if (carousel && TRANSITIONEND) {
            var eve = {};
            eve[TRANSITIONEND] = onTransitionEnd;
            (0, $2d450f9a54805e30$export$aadfb65bee660f96)(container, eve);
        }
        if (touch) (0, $2d450f9a54805e30$export$aadfb65bee660f96)(container, touchEvents, options.preventScrollOnTouch);
        if (mouseDrag) (0, $2d450f9a54805e30$export$aadfb65bee660f96)(container, dragEvents);
        if (arrowKeys) (0, $2d450f9a54805e30$export$aadfb65bee660f96)(doc, docmentKeydownEvent);
        if (nested === "inner") events.on("outerResized", function() {
            resizeTasks();
            events.emit("innerLoaded", info());
        });
        else if (responsive || fixedWidth || autoWidth || autoHeight || !horizontal) (0, $2d450f9a54805e30$export$aadfb65bee660f96)(win, {
            "resize": onResize
        });
        if (autoHeight) {
            if (nested === "outer") events.on("innerLoaded", doAutoHeight);
            else if (!disable) doAutoHeight();
        }
        doLazyLoad();
        if (disable) disableSlider();
        else if (freeze) freezeSlider();
        events.on("indexChanged", additionalUpdates);
        if (nested === "inner") events.emit("innerLoaded", info());
        if (typeof onInit === "function") onInit(info());
        isOn = true;
    }
    function destroy() {
        // sheet
        sheet.disabled = true;
        if (sheet.ownerNode) sheet.ownerNode.remove();
        // remove win event listeners
        (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(win, {
            "resize": onResize
        });
        // arrowKeys, controls, nav
        if (arrowKeys) (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(doc, docmentKeydownEvent);
        if (controlsContainer) (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(controlsContainer, controlsEvents);
        if (navContainer) (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(navContainer, navEvents);
        // autoplay
        (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(container, hoverEvents);
        (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(container, visibilityEvent);
        if (autoplayButton) (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(autoplayButton, {
            "click": toggleAutoplay
        });
        if (autoplay) clearInterval(autoplayTimer);
        // container
        if (carousel && TRANSITIONEND) {
            var eve = {};
            eve[TRANSITIONEND] = onTransitionEnd;
            (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(container, eve);
        }
        if (touch) (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(container, touchEvents);
        if (mouseDrag) (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(container, dragEvents);
        // cache Object values in options && reset HTML
        var htmlList = [
            containerHTML,
            controlsContainerHTML,
            prevButtonHTML,
            nextButtonHTML,
            navContainerHTML,
            autoplayButtonHTML
        ];
        tnsList.forEach(function(item, i) {
            var el = item === "container" ? outerWrapper : options[item];
            if (typeof el === "object" && el) {
                var prevEl = el.previousElementSibling ? el.previousElementSibling : false, parentEl = el.parentNode;
                el.outerHTML = htmlList[i];
                options[item] = prevEl ? prevEl.nextElementSibling : parentEl.firstElementChild;
            }
        });
        // reset variables
        tnsList = animateIn = animateOut = animateDelay = animateNormal = horizontal = outerWrapper = innerWrapper = container = containerParent = containerHTML = slideItems = slideCount = breakpointZone = windowWidth = autoWidth = fixedWidth = edgePadding = gutter = viewport = items = slideBy = viewportMax = arrowKeys = speed = rewind = loop = autoHeight = sheet = lazyload = slidePositions = slideItemsOut = cloneCount = slideCountNew = hasRightDeadZone = rightBoundary = updateIndexBeforeTransform = transformAttr = transformPrefix = transformPostfix = getIndexMax = index = indexCached = indexMin = indexMax = resizeTimer = swipeAngle = moveDirectionExpected = running = onInit = events = newContainerClasses = slideId = disable = disabled = freezable = freeze = frozen = controlsEvents = navEvents = hoverEvents = visibilityEvent = docmentKeydownEvent = touchEvents = dragEvents = hasControls = hasNav = navAsThumbnails = hasAutoplay = hasTouch = hasMouseDrag = slideActiveClass = imgCompleteClass = imgEvents = imgsComplete = controls = controlsText = controlsContainer = controlsContainerHTML = prevButton = nextButton = prevIsButton = nextIsButton = nav = navContainer = navContainerHTML = navItems = pages = pagesCached = navClicked = navCurrentIndex = navCurrentIndexCached = navActiveClass = navStr = navStrCurrent = autoplay = autoplayTimeout = autoplayDirection = autoplayText = autoplayHoverPause = autoplayButton = autoplayButtonHTML = autoplayResetOnVisibility = autoplayHtmlStrings = autoplayTimer = animating = autoplayHoverPaused = autoplayUserPaused = autoplayVisibilityPaused = initPosition = lastPosition = translateInit = disX = disY = panStart = rafIndex = getDist = touch = mouseDrag = null;
        // check variables
        // [animateIn, animateOut, animateDelay, animateNormal, horizontal, outerWrapper, innerWrapper, container, containerParent, containerHTML, slideItems, slideCount, breakpointZone, windowWidth, autoWidth, fixedWidth, edgePadding, gutter, viewport, items, slideBy, viewportMax, arrowKeys, speed, rewind, loop, autoHeight, sheet, lazyload, slidePositions, slideItemsOut, cloneCount, slideCountNew, hasRightDeadZone, rightBoundary, updateIndexBeforeTransform, transformAttr, transformPrefix, transformPostfix, getIndexMax, index, indexCached, indexMin, indexMax, resizeTimer, swipeAngle, moveDirectionExpected, running, onInit, events, newContainerClasses, slideId, disable, disabled, freezable, freeze, frozen, controlsEvents, navEvents, hoverEvents, visibilityEvent, docmentKeydownEvent, touchEvents, dragEvents, hasControls, hasNav, navAsThumbnails, hasAutoplay, hasTouch, hasMouseDrag, slideActiveClass, imgCompleteClass, imgEvents, imgsComplete, controls, controlsText, controlsContainer, controlsContainerHTML, prevButton, nextButton, prevIsButton, nextIsButton, nav, navContainer, navContainerHTML, navItems, pages, pagesCached, navClicked, navCurrentIndex, navCurrentIndexCached, navActiveClass, navStr, navStrCurrent, autoplay, autoplayTimeout, autoplayDirection, autoplayText, autoplayHoverPause, autoplayButton, autoplayButtonHTML, autoplayResetOnVisibility, autoplayHtmlStrings, autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused, initPosition, lastPosition, translateInit, disX, disY, panStart, rafIndex, getDist, touch, mouseDrag ].forEach(function(item) { if (item !== null) { console.log(item); } });
        for(var a in this)if (a !== "rebuild") this[a] = null;
        isOn = false;
    }
    // === ON RESIZE ===
    // responsive || fixedWidth || autoWidth || !horizontal
    function onResize(e) {
        (0, $841e85ee868dd0d4$export$27f233d61a9e2fa4)(function() {
            resizeTasks(getEvent(e));
        });
    }
    function resizeTasks(e) {
        if (!isOn) return;
        if (nested === "outer") events.emit("outerResized", info(e));
        windowWidth = getWindowWidth();
        var bpChanged, breakpointZoneTem = breakpointZone, needContainerTransform = false;
        if (responsive) {
            setBreakpointZone();
            bpChanged = breakpointZoneTem !== breakpointZone;
            // if (hasRightDeadZone) { needContainerTransform = true; } // *?
            if (bpChanged) events.emit("newBreakpointStart", info(e));
        }
        var indChanged, itemsChanged, itemsTem = items, disableTem = disable, freezeTem = freeze, arrowKeysTem = arrowKeys, controlsTem = controls, navTem = nav, touchTem = touch, mouseDragTem = mouseDrag, autoplayTem = autoplay, autoplayHoverPauseTem = autoplayHoverPause, autoplayResetOnVisibilityTem = autoplayResetOnVisibility, indexTem = index;
        if (bpChanged) {
            var fixedWidthTem = fixedWidth, autoHeightTem = autoHeight, controlsTextTem = controlsText, centerTem = center, autoplayTextTem = autoplayText;
            if (!CSSMQ) var gutterTem = gutter, edgePaddingTem = edgePadding;
        }
        // get option:
        // fixed width: viewport, fixedWidth, gutter => items
        // others: window width => all variables
        // all: items => slideBy
        arrowKeys = getOption("arrowKeys");
        controls = getOption("controls");
        nav = getOption("nav");
        touch = getOption("touch");
        center = getOption("center");
        mouseDrag = getOption("mouseDrag");
        autoplay = getOption("autoplay");
        autoplayHoverPause = getOption("autoplayHoverPause");
        autoplayResetOnVisibility = getOption("autoplayResetOnVisibility");
        if (bpChanged) {
            disable = getOption("disable");
            fixedWidth = getOption("fixedWidth");
            speed = getOption("speed");
            autoHeight = getOption("autoHeight");
            controlsText = getOption("controlsText");
            autoplayText = getOption("autoplayText");
            autoplayTimeout = getOption("autoplayTimeout");
            if (!CSSMQ) {
                edgePadding = getOption("edgePadding");
                gutter = getOption("gutter");
            }
        }
        // update options
        resetVariblesWhenDisable(disable);
        viewport = getViewportWidth(); // <= edgePadding, gutter
        if ((!horizontal || autoWidth) && !disable) {
            setSlidePositions();
            if (!horizontal) {
                updateContentWrapperHeight(); // <= setSlidePositions
                needContainerTransform = true;
            }
        }
        if (fixedWidth || autoWidth) {
            rightBoundary = getRightBoundary(); // autoWidth: <= viewport, slidePositions, gutter
            // fixedWidth: <= viewport, fixedWidth, gutter
            indexMax = getIndexMax(); // autoWidth: <= rightBoundary, slidePositions
        // fixedWidth: <= rightBoundary, fixedWidth, gutter
        }
        if (bpChanged || fixedWidth) {
            items = getOption("items");
            slideBy = getOption("slideBy");
            itemsChanged = items !== itemsTem;
            if (itemsChanged) {
                if (!fixedWidth && !autoWidth) indexMax = getIndexMax();
                 // <= items
                // check index before transform in case
                // slider reach the right edge then items become bigger
                updateIndex();
            }
        }
        if (bpChanged) {
            if (disable !== disableTem) {
                if (disable) disableSlider();
                else enableSlider(); // <= slidePositions, rightBoundary, indexMax
            }
        }
        if (freezable && (bpChanged || fixedWidth || autoWidth)) {
            freeze = getFreeze(); // <= autoWidth: slidePositions, gutter, viewport, rightBoundary
            // <= fixedWidth: fixedWidth, gutter, rightBoundary
            // <= others: items
            if (freeze !== freezeTem) {
                if (freeze) {
                    doContainerTransform(getContainerTransformValue(getStartIndex(0)));
                    freezeSlider();
                } else {
                    unfreezeSlider();
                    needContainerTransform = true;
                }
            }
        }
        resetVariblesWhenDisable(disable || freeze); // controls, nav, touch, mouseDrag, arrowKeys, autoplay, autoplayHoverPause, autoplayResetOnVisibility
        if (!autoplay) autoplayHoverPause = autoplayResetOnVisibility = false;
        if (arrowKeys !== arrowKeysTem) arrowKeys ? (0, $2d450f9a54805e30$export$aadfb65bee660f96)(doc, docmentKeydownEvent) : (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(doc, docmentKeydownEvent);
        if (controls !== controlsTem) {
            if (controls) {
                if (controlsContainer) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(controlsContainer);
                else {
                    if (prevButton) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(prevButton);
                    if (nextButton) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(nextButton);
                }
            } else if (controlsContainer) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(controlsContainer);
            else {
                if (prevButton) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(prevButton);
                if (nextButton) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(nextButton);
            }
        }
        if (nav !== navTem) {
            if (nav) {
                (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(navContainer);
                updateNavVisibility();
            } else (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(navContainer);
        }
        if (touch !== touchTem) touch ? (0, $2d450f9a54805e30$export$aadfb65bee660f96)(container, touchEvents, options.preventScrollOnTouch) : (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(container, touchEvents);
        if (mouseDrag !== mouseDragTem) mouseDrag ? (0, $2d450f9a54805e30$export$aadfb65bee660f96)(container, dragEvents) : (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(container, dragEvents);
        if (autoplay !== autoplayTem) {
            if (autoplay) {
                if (autoplayButton) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(autoplayButton);
                if (!animating && !autoplayUserPaused) startAutoplay();
            } else {
                if (autoplayButton) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(autoplayButton);
                if (animating) stopAutoplay();
            }
        }
        if (autoplayHoverPause !== autoplayHoverPauseTem) autoplayHoverPause ? (0, $2d450f9a54805e30$export$aadfb65bee660f96)(container, hoverEvents) : (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(container, hoverEvents);
        if (autoplayResetOnVisibility !== autoplayResetOnVisibilityTem) autoplayResetOnVisibility ? (0, $2d450f9a54805e30$export$aadfb65bee660f96)(doc, visibilityEvent) : (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(doc, visibilityEvent);
        if (bpChanged) {
            if (fixedWidth !== fixedWidthTem || center !== centerTem) needContainerTransform = true;
            if (autoHeight !== autoHeightTem) {
                if (!autoHeight) innerWrapper.style.height = "";
            }
            if (controls && controlsText !== controlsTextTem) {
                prevButton.innerHTML = controlsText[0];
                nextButton.innerHTML = controlsText[1];
            }
            if (autoplayButton && autoplayText !== autoplayTextTem) {
                var i = autoplay ? 1 : 0, html = autoplayButton.innerHTML, len = html.length - autoplayTextTem[i].length;
                if (html.substring(len) === autoplayTextTem[i]) autoplayButton.innerHTML = html.substring(0, len) + autoplayText[i];
            }
        } else if (center && (fixedWidth || autoWidth)) needContainerTransform = true;
        if (itemsChanged || fixedWidth && !autoWidth) {
            pages = getPages();
            updateNavVisibility();
        }
        indChanged = index !== indexTem;
        if (indChanged) {
            events.emit("indexChanged", info());
            needContainerTransform = true;
        } else if (itemsChanged) {
            if (!indChanged) additionalUpdates();
        } else if (fixedWidth || autoWidth) {
            doLazyLoad();
            updateSlideStatus();
            updateLiveRegion();
        }
        if (itemsChanged && !carousel) updateGallerySlidePositions();
        if (!disable && !freeze) {
            // non-mediaqueries: IE8
            if (bpChanged && !CSSMQ) {
                // middle wrapper styles
                // inner wrapper styles
                if (edgePadding !== edgePaddingTem || gutter !== gutterTem) innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, speed, autoHeight);
                if (horizontal) {
                    // container styles
                    if (carousel) container.style.width = getContainerWidth(fixedWidth, gutter, items);
                    // slide styles
                    var str = getSlideWidthStyle(fixedWidth, gutter, items) + getSlideGutterStyle(gutter);
                    // remove the last line and
                    // add new styles
                    (0, $290e8f413288fb29$export$271e480b8a432c4a)(sheet, (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet) - 1);
                    (0, $1a90d19cf20fcd68$export$bf97e331026f75ba)(sheet, "#" + slideId + " > .tns-item", str, (0, $97bce8d8c89c4190$export$ccd7e907f4f59892)(sheet));
                }
            }
            // auto height
            if (autoHeight) doAutoHeight();
            if (needContainerTransform) {
                doContainerTransformSilent();
                indexCached = index;
            }
        }
        if (bpChanged) events.emit("newBreakpointEnd", info(e));
    }
    // === INITIALIZATION FUNCTIONS === //
    function getFreeze() {
        if (!fixedWidth && !autoWidth) {
            var a = center ? items - (items - 1) / 2 : items;
            return slideCount <= a;
        }
        var width = fixedWidth ? (fixedWidth + gutter) * slideCount : slidePositions[slideCount], vp = edgePadding ? viewport + edgePadding * 2 : viewport + gutter;
        if (center) vp -= fixedWidth ? (viewport - fixedWidth) / 2 : (viewport - (slidePositions[index + 1] - slidePositions[index] - gutter)) / 2;
        return width <= vp;
    }
    function setBreakpointZone() {
        breakpointZone = 0;
        for(var bp in responsive){
            bp = parseInt(bp); // convert string to number
            if (windowWidth >= bp) breakpointZone = bp;
        }
    }
    // (slideBy, indexMin, indexMax) => index
    var updateIndex = function() {
        return loop ? carousel ? // loop + carousel
        function() {
            var leftEdge = indexMin, rightEdge = indexMax;
            leftEdge += slideBy;
            rightEdge -= slideBy;
            // adjust edges when has edge paddings
            // or fixed-width slider with extra space on the right side
            if (edgePadding) {
                leftEdge += 1;
                rightEdge -= 1;
            } else if (fixedWidth) {
                if ((viewport + gutter) % (fixedWidth + gutter)) rightEdge -= 1;
            }
            if (cloneCount) {
                if (index > rightEdge) index -= slideCount;
                else if (index < leftEdge) index += slideCount;
            }
        } : // loop + gallery
        function() {
            if (index > indexMax) while(index >= indexMin + slideCount)index -= slideCount;
            else if (index < indexMin) while(index <= indexMax - slideCount)index += slideCount;
        } : // non-loop
        function() {
            index = Math.max(indexMin, Math.min(indexMax, index));
        };
    }();
    function disableUI() {
        if (!autoplay && autoplayButton) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(autoplayButton);
        if (!nav && navContainer) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(navContainer);
        if (!controls) {
            if (controlsContainer) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(controlsContainer);
            else {
                if (prevButton) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(prevButton);
                if (nextButton) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(nextButton);
            }
        }
    }
    function enableUI() {
        if (autoplay && autoplayButton) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(autoplayButton);
        if (nav && navContainer) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(navContainer);
        if (controls) {
            if (controlsContainer) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(controlsContainer);
            else {
                if (prevButton) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(prevButton);
                if (nextButton) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(nextButton);
            }
        }
    }
    function freezeSlider() {
        if (frozen) return;
        // remove edge padding from inner wrapper
        if (edgePadding) innerWrapper.style.margin = "0px";
        // add class tns-transparent to cloned slides
        if (cloneCount) {
            var str = "tns-transparent";
            for(var i = cloneCount; i--;){
                if (carousel) (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(slideItems[i], str);
                (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(slideItems[slideCountNew - i - 1], str);
            }
        }
        // update tools
        disableUI();
        frozen = true;
    }
    function unfreezeSlider() {
        if (!frozen) return;
        // restore edge padding for inner wrapper
        // for mordern browsers
        if (edgePadding && CSSMQ) innerWrapper.style.margin = "";
        // remove class tns-transparent to cloned slides
        if (cloneCount) {
            var str = "tns-transparent";
            for(var i = cloneCount; i--;){
                if (carousel) (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(slideItems[i], str);
                (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(slideItems[slideCountNew - i - 1], str);
            }
        }
        // update tools
        enableUI();
        frozen = false;
    }
    function disableSlider() {
        if (disabled) return;
        sheet.disabled = true;
        container.className = container.className.replace(newContainerClasses.substring(1), "");
        (0, $374312ce9bdfbef2$export$711225beb0f1ef57)(container, [
            "style"
        ]);
        if (loop) for(var j = cloneCount; j--;){
            if (carousel) (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(slideItems[j]);
            (0, $b6b059ab1be1bedb$export$7669482c90f5c50f)(slideItems[slideCountNew - j - 1]);
        }
        // vertical slider
        if (!horizontal || !carousel) (0, $374312ce9bdfbef2$export$711225beb0f1ef57)(innerWrapper, [
            "style"
        ]);
        // gallery
        if (!carousel) for(var i = index, l = index + slideCount; i < l; i++){
            var item = slideItems[i];
            (0, $374312ce9bdfbef2$export$711225beb0f1ef57)(item, [
                "style"
            ]);
            (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, animateIn);
            (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, animateNormal);
        }
        // update tools
        disableUI();
        disabled = true;
    }
    function enableSlider() {
        if (!disabled) return;
        sheet.disabled = false;
        container.className += newContainerClasses;
        doContainerTransformSilent();
        if (loop) for(var j = cloneCount; j--;){
            if (carousel) (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(slideItems[j]);
            (0, $7e4aafbbd7b5f772$export$998191bfdf710c72)(slideItems[slideCountNew - j - 1]);
        }
        // gallery
        if (!carousel) for(var i = index, l = index + slideCount; i < l; i++){
            var item = slideItems[i], classN = i < index + items ? animateIn : animateNormal;
            item.style.left = (i - index) * 100 / items + "%";
            (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, classN);
        }
        // update tools
        enableUI();
        disabled = false;
    }
    function updateLiveRegion() {
        var str = getLiveRegionStr();
        if (liveregionCurrent.innerHTML !== str) liveregionCurrent.innerHTML = str;
    }
    function getLiveRegionStr() {
        var arr = getVisibleSlideRange(), start = arr[0] + 1, end = arr[1] + 1;
        return start === end ? start + "" : start + " to " + end;
    }
    function getVisibleSlideRange(val) {
        if (val == null) val = getContainerTransformValue();
        var start = index, end, rangestart, rangeend;
        // get range start, range end for autoWidth and fixedWidth
        if (center || edgePadding) {
            if (autoWidth || fixedWidth) {
                rangestart = -(parseFloat(val) + edgePadding);
                rangeend = rangestart + viewport + edgePadding * 2;
            }
        } else if (autoWidth) {
            rangestart = slidePositions[index];
            rangeend = rangestart + viewport;
        }
        // get start, end
        // - check auto width
        if (autoWidth) slidePositions.forEach(function(point, i) {
            if (i < slideCountNew) {
                if ((center || edgePadding) && point <= rangestart + 0.5) start = i;
                if (rangeend - point >= 0.5) end = i;
            }
        });
        else {
            if (fixedWidth) {
                var cell = fixedWidth + gutter;
                if (center || edgePadding) {
                    start = Math.floor(rangestart / cell);
                    end = Math.ceil(rangeend / cell - 1);
                } else end = start + Math.ceil(viewport / cell) - 1;
            } else if (center || edgePadding) {
                var a = items - 1;
                if (center) {
                    start -= a / 2;
                    end = index + a / 2;
                } else end = index + a;
                if (edgePadding) {
                    var b = edgePadding * items / viewport;
                    start -= b;
                    end += b;
                }
                start = Math.floor(start);
                end = Math.ceil(end);
            } else end = start + items - 1;
            start = Math.max(start, 0);
            end = Math.min(end, slideCountNew - 1);
        }
        return [
            start,
            end
        ];
    }
    function doLazyLoad() {
        if (lazyload && !disable) {
            var arg = getVisibleSlideRange();
            arg.push(lazyloadSelector);
            getImageArray.apply(null, arg).forEach(function(img) {
                if (!(0, $e4fd7ed3fd7a85e9$export$4ea3d958472af68f)(img, imgCompleteClass)) {
                    // stop propagation transitionend event to container
                    var eve = {};
                    eve[TRANSITIONEND] = function(e) {
                        e.stopPropagation();
                    };
                    (0, $2d450f9a54805e30$export$aadfb65bee660f96)(img, eve);
                    (0, $2d450f9a54805e30$export$aadfb65bee660f96)(img, imgEvents);
                    // update src
                    img.src = (0, $36eae2ea1433e2ee$export$6a93fe6b2b4c71a0)(img, "data-src");
                    // update srcset
                    var srcset = (0, $36eae2ea1433e2ee$export$6a93fe6b2b4c71a0)(img, "data-srcset");
                    if (srcset) img.srcset = srcset;
                    (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(img, "loading");
                }
            });
        }
    }
    function onImgLoaded(e) {
        imgLoaded(getTarget(e));
    }
    function onImgFailed(e) {
        imgFailed(getTarget(e));
    }
    function imgLoaded(img) {
        (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(img, "loaded");
        imgCompleted(img);
    }
    function imgFailed(img) {
        (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(img, "failed");
        imgCompleted(img);
    }
    function imgCompleted(img) {
        (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(img, imgCompleteClass);
        (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(img, "loading");
        (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(img, imgEvents);
    }
    function getImageArray(start, end, imgSelector) {
        var imgs = [];
        if (!imgSelector) imgSelector = "img";
        while(start <= end){
            (0, $c4d187697d100d42$export$4b80e395e36b5a56)(slideItems[start].querySelectorAll(imgSelector), function(img) {
                imgs.push(img);
            });
            start++;
        }
        return imgs;
    }
    // check if all visible images are loaded
    // and update container height if it's done
    function doAutoHeight() {
        var imgs = getImageArray.apply(null, getVisibleSlideRange());
        (0, $841e85ee868dd0d4$export$27f233d61a9e2fa4)(function() {
            imgsLoadedCheck(imgs, updateInnerWrapperHeight);
        });
    }
    function imgsLoadedCheck(imgs, cb) {
        // execute callback function if all images are complete
        if (imgsComplete) return cb();
        // check image classes
        imgs.forEach(function(img, index) {
            if (!lazyload && img.complete) imgCompleted(img);
             // Check image.complete
            if ((0, $e4fd7ed3fd7a85e9$export$4ea3d958472af68f)(img, imgCompleteClass)) imgs.splice(index, 1);
        });
        // execute callback function if selected images are all complete
        if (!imgs.length) return cb();
        // otherwise execute this functiona again
        (0, $841e85ee868dd0d4$export$27f233d61a9e2fa4)(function() {
            imgsLoadedCheck(imgs, cb);
        });
    }
    function additionalUpdates() {
        doLazyLoad();
        updateSlideStatus();
        updateLiveRegion();
        updateControlsStatus();
        updateNavStatus();
    }
    function update_carousel_transition_duration() {
        if (carousel && autoHeight) middleWrapper.style[TRANSITIONDURATION] = speed / 1000 + "s";
    }
    function getMaxSlideHeight(slideStart, slideRange) {
        var heights = [];
        for(var i = slideStart, l = Math.min(slideStart + slideRange, slideCountNew); i < l; i++)heights.push(slideItems[i].offsetHeight);
        return Math.max.apply(null, heights);
    }
    // update inner wrapper height
    // 1. get the max-height of the visible slides
    // 2. set transitionDuration to speed
    // 3. update inner wrapper height to max-height
    // 4. set transitionDuration to 0s after transition done
    function updateInnerWrapperHeight() {
        var maxHeight = autoHeight ? getMaxSlideHeight(index, items) : getMaxSlideHeight(cloneCount, slideCount), wp = middleWrapper ? middleWrapper : innerWrapper;
        if (wp.style.height !== maxHeight) wp.style.height = maxHeight + "px";
    }
    // get the distance from the top edge of the first slide to each slide
    // (init) => slidePositions
    function setSlidePositions() {
        slidePositions = [
            0
        ];
        var attr = horizontal ? "left" : "top", attr2 = horizontal ? "right" : "bottom", base = slideItems[0].getBoundingClientRect()[attr];
        (0, $c4d187697d100d42$export$4b80e395e36b5a56)(slideItems, function(item, i) {
            // skip the first slide
            if (i) slidePositions.push(item.getBoundingClientRect()[attr] - base);
            // add the end edge
            if (i === slideCountNew - 1) slidePositions.push(item.getBoundingClientRect()[attr2] - base);
        });
    }
    // update slide
    function updateSlideStatus() {
        var range = getVisibleSlideRange(), start = range[0], end = range[1];
        (0, $c4d187697d100d42$export$4b80e395e36b5a56)(slideItems, function(item, i) {
            // show slides
            if (i >= start && i <= end) {
                if ((0, $92c19f95ffd892da$export$5608640b1bf2f6d7)(item, "aria-hidden")) {
                    (0, $374312ce9bdfbef2$export$711225beb0f1ef57)(item, [
                        "aria-hidden",
                        "tabindex"
                    ]);
                    (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, slideActiveClass);
                }
            } else if (!(0, $92c19f95ffd892da$export$5608640b1bf2f6d7)(item, "aria-hidden")) {
                (0, $fc4786701fd188a9$export$7e45664a2081efb1)(item, {
                    "aria-hidden": "true",
                    "tabindex": "-1"
                });
                (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, slideActiveClass);
            }
        });
    }
    // gallery: update slide position
    function updateGallerySlidePositions() {
        var l = index + Math.min(slideCount, items);
        for(var i = slideCountNew; i--;){
            var item = slideItems[i];
            if (i >= index && i < l) {
                // add transitions to visible slides when adjusting their positions
                (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, "tns-moving");
                item.style.left = (i - index) * 100 / items + "%";
                (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, animateIn);
                (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, animateNormal);
            } else if (item.style.left) {
                item.style.left = "";
                (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, animateNormal);
                (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, animateIn);
            }
            // remove outlet animation
            (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, animateOut);
        }
        // removing '.tns-moving'
        setTimeout(function() {
            (0, $c4d187697d100d42$export$4b80e395e36b5a56)(slideItems, function(el) {
                (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(el, "tns-moving");
            });
        }, 300);
    }
    // set tabindex on Nav
    function updateNavStatus() {
        // get current nav
        if (nav) {
            navCurrentIndex = navClicked >= 0 ? navClicked : getCurrentNavIndex();
            navClicked = -1;
            if (navCurrentIndex !== navCurrentIndexCached) {
                var navPrev = navItems[navCurrentIndexCached], navCurrent = navItems[navCurrentIndex];
                (0, $fc4786701fd188a9$export$7e45664a2081efb1)(navPrev, {
                    "tabindex": "-1",
                    "aria-label": navStr + (navCurrentIndexCached + 1)
                });
                (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(navPrev, navActiveClass);
                (0, $fc4786701fd188a9$export$7e45664a2081efb1)(navCurrent, {
                    "aria-label": navStr + (navCurrentIndex + 1) + navStrCurrent
                });
                (0, $374312ce9bdfbef2$export$711225beb0f1ef57)(navCurrent, "tabindex");
                (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(navCurrent, navActiveClass);
                navCurrentIndexCached = navCurrentIndex;
            }
        }
    }
    function getLowerCaseNodeName(el) {
        return el.nodeName.toLowerCase();
    }
    function isButton(el) {
        return getLowerCaseNodeName(el) === "button";
    }
    function isAriaDisabled(el) {
        return el.getAttribute("aria-disabled") === "true";
    }
    function disEnableElement(isButton, el, val) {
        if (isButton) el.disabled = val;
        else el.setAttribute("aria-disabled", val.toString());
    }
    // set 'disabled' to true on controls when reach the edges
    function updateControlsStatus() {
        if (!controls || rewind || loop) return;
        var prevDisabled = prevIsButton ? prevButton.disabled : isAriaDisabled(prevButton), nextDisabled = nextIsButton ? nextButton.disabled : isAriaDisabled(nextButton), disablePrev = index <= indexMin ? true : false, disableNext = !rewind && index >= indexMax ? true : false;
        if (disablePrev && !prevDisabled) disEnableElement(prevIsButton, prevButton, true);
        if (!disablePrev && prevDisabled) disEnableElement(prevIsButton, prevButton, false);
        if (disableNext && !nextDisabled) disEnableElement(nextIsButton, nextButton, true);
        if (!disableNext && nextDisabled) disEnableElement(nextIsButton, nextButton, false);
    }
    // set duration
    function resetDuration(el, str) {
        if (TRANSITIONDURATION) el.style[TRANSITIONDURATION] = str;
    }
    function getSliderWidth() {
        return fixedWidth ? (fixedWidth + gutter) * slideCountNew : slidePositions[slideCountNew];
    }
    function getCenterGap(num) {
        if (num == null) num = index;
        var gap = edgePadding ? gutter : 0;
        return autoWidth ? (viewport - gap - (slidePositions[num + 1] - slidePositions[num] - gutter)) / 2 : fixedWidth ? (viewport - fixedWidth) / 2 : (items - 1) / 2;
    }
    function getRightBoundary() {
        var gap = edgePadding ? gutter : 0, result = viewport + gap - getSliderWidth();
        if (center && !loop) result = fixedWidth ? -(fixedWidth + gutter) * (slideCountNew - 1) - getCenterGap() : getCenterGap(slideCountNew - 1) - slidePositions[slideCountNew - 1];
        if (result > 0) result = 0;
        return result;
    }
    function getContainerTransformValue(num) {
        if (num == null) num = index;
        var val;
        if (horizontal && !autoWidth) {
            if (fixedWidth) {
                val = -(fixedWidth + gutter) * num;
                if (center) val += getCenterGap();
            } else {
                var denominator = TRANSFORM ? slideCountNew : items;
                if (center) num -= getCenterGap();
                val = -num * 100 / denominator;
            }
        } else {
            val = -slidePositions[num];
            if (center && autoWidth) val += getCenterGap();
        }
        if (hasRightDeadZone) val = Math.max(val, rightBoundary);
        val += horizontal && !autoWidth && !fixedWidth ? "%" : "px";
        return val;
    }
    function doContainerTransformSilent(val) {
        resetDuration(container, "0s");
        doContainerTransform(val);
    }
    function doContainerTransform(val) {
        if (val == null) val = getContainerTransformValue();
        container.style[transformAttr] = transformPrefix + val + transformPostfix;
    }
    function animateSlide(number, classOut, classIn, isOut) {
        var l = number + items;
        if (!loop) l = Math.min(l, slideCountNew);
        for(var i = number; i < l; i++){
            var item = slideItems[i];
            // set item positions
            if (!isOut) item.style.left = (i - index) * 100 / items + "%";
            if (animateDelay && TRANSITIONDELAY) item.style[TRANSITIONDELAY] = item.style[ANIMATIONDELAY] = animateDelay * (i - number) / 1000 + "s";
            (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, classOut);
            (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, classIn);
            if (isOut) slideItemsOut.push(item);
        }
    }
    // make transfer after click/drag:
    // 1. change 'transform' property for mordern browsers
    // 2. change 'left' property for legacy browsers
    var transformCore = function() {
        return carousel ? function() {
            resetDuration(container, "");
            if (TRANSITIONDURATION || !speed) {
                // for morden browsers with non-zero duration or
                // zero duration for all browsers
                doContainerTransform();
                // run fallback function manually
                // when duration is 0 / container is hidden
                if (!speed || !(0, $807f43eecb4b0d07$export$795910f5f15a9633)(container)) onTransitionEnd();
            } else // for old browser with non-zero duration
            (0, $9e1eeb371de7034f$export$e2705a83c013f564)(container, transformAttr, transformPrefix, transformPostfix, getContainerTransformValue(), speed, onTransitionEnd);
            if (!horizontal) updateContentWrapperHeight();
        } : function() {
            slideItemsOut = [];
            var eve = {};
            eve[TRANSITIONEND] = eve[ANIMATIONEND] = onTransitionEnd;
            (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(slideItems[indexCached], eve);
            (0, $2d450f9a54805e30$export$aadfb65bee660f96)(slideItems[index], eve);
            animateSlide(indexCached, animateIn, animateOut, true);
            animateSlide(index, animateNormal, animateIn);
            // run fallback function manually
            // when transition or animation not supported / duration is 0
            if (!TRANSITIONEND || !ANIMATIONEND || !speed || !(0, $807f43eecb4b0d07$export$795910f5f15a9633)(container)) onTransitionEnd();
        };
    }();
    function render(e, sliderMoved) {
        if (updateIndexBeforeTransform) updateIndex();
        // render when slider was moved (touch or drag) even though index may not change
        if (index !== indexCached || sliderMoved) {
            // events
            events.emit("indexChanged", info());
            events.emit("transitionStart", info());
            if (autoHeight) doAutoHeight();
            // pause autoplay when click or keydown from user
            if (animating && e && [
                "click",
                "keydown"
            ].indexOf(e.type) >= 0) stopAutoplay();
            running = true;
            transformCore();
        }
    }
    /*
   * Transfer prefixed properties to the same format
   * CSS: -Webkit-Transform => webkittransform
   * JS: WebkitTransform => webkittransform
   * @param {string} str - property
   *
   */ function strTrans(str) {
        return str.toLowerCase().replace(/-/g, "");
    }
    // AFTER TRANSFORM
    // Things need to be done after a transfer:
    // 1. check index
    // 2. add classes to visible slide
    // 3. disable controls buttons when reach the first/last slide in non-loop slider
    // 4. update nav status
    // 5. lazyload images
    // 6. update container height
    function onTransitionEnd(event) {
        // check running on gallery mode
        // make sure trantionend/animationend events run only once
        if (carousel || running) {
            events.emit("transitionEnd", info(event));
            if (!carousel && slideItemsOut.length > 0) for(var i = 0; i < slideItemsOut.length; i++){
                var item = slideItemsOut[i];
                // set item positions
                item.style.left = "";
                if (ANIMATIONDELAY && TRANSITIONDELAY) {
                    item.style[ANIMATIONDELAY] = "";
                    item.style[TRANSITIONDELAY] = "";
                }
                (0, $91ec85d1e7d05de6$export$c2255604a80b4506)(item, animateOut);
                (0, $58aedeabc9b57e85$export$d2cf6cd1dc7067d3)(item, animateNormal);
            }
            /* update slides, nav, controls after checking ...
       * => legacy browsers who don't support 'event'
       *    have to check event first, otherwise event.target will cause an error
       * => or 'gallery' mode:
       *   + event target is slide item
       * => or 'carousel' mode:
       *   + event target is container,
       *   + event.property is the same with transform attribute
       */ if (!event || !carousel && event.target.parentNode === container || event.target === container && strTrans(event.propertyName) === strTrans(transformAttr)) {
                if (!updateIndexBeforeTransform) {
                    var indexTem = index;
                    updateIndex();
                    if (index !== indexTem) {
                        events.emit("indexChanged", info());
                        doContainerTransformSilent();
                    }
                }
                if (nested === "inner") events.emit("innerLoaded", info());
                running = false;
                indexCached = index;
            }
        }
    }
    // # ACTIONS
    function goTo(targetIndex, e) {
        if (freeze) return;
        // prev slideBy
        if (targetIndex === "prev") onControlsClick(e, -1);
        else if (targetIndex === "next") onControlsClick(e, 1);
        else {
            if (running) {
                if (preventActionWhenRunning) return;
                else onTransitionEnd();
            }
            var absIndex = getAbsIndex(), indexGap = 0;
            if (targetIndex === "first") indexGap = -absIndex;
            else if (targetIndex === "last") indexGap = carousel ? slideCount - items - absIndex : slideCount - 1 - absIndex;
            else {
                if (typeof targetIndex !== "number") targetIndex = parseInt(targetIndex);
                if (!isNaN(targetIndex)) {
                    // from directly called goTo function
                    if (!e) targetIndex = Math.max(0, Math.min(slideCount - 1, targetIndex));
                    indexGap = targetIndex - absIndex;
                }
            }
            // gallery: make sure new page won't overlap with current page
            if (!carousel && indexGap && Math.abs(indexGap) < items) {
                var factor = indexGap > 0 ? 1 : -1;
                indexGap += index + indexGap - slideCount >= indexMin ? slideCount * factor : slideCount * 2 * factor * -1;
            }
            index += indexGap;
            // make sure index is in range
            if (carousel && loop) {
                if (index < indexMin) index += slideCount;
                if (index > indexMax) index -= slideCount;
            }
            // if index is changed, start rendering
            if (getAbsIndex(index) !== getAbsIndex(indexCached)) render(e);
        }
    }
    // on controls click
    function onControlsClick(e, dir) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        var passEventObject;
        if (!dir) {
            e = getEvent(e);
            var target = getTarget(e);
            while(target !== controlsContainer && [
                prevButton,
                nextButton
            ].indexOf(target) < 0)target = target.parentNode;
            var targetIn = [
                prevButton,
                nextButton
            ].indexOf(target);
            if (targetIn >= 0) {
                passEventObject = true;
                dir = targetIn === 0 ? -1 : 1;
            }
        }
        if (rewind) {
            if (index === indexMin && dir === -1) {
                goTo("last", e);
                return;
            } else if (index === indexMax && dir === 1) {
                goTo("first", e);
                return;
            }
        }
        if (dir) {
            index += slideBy * dir;
            if (autoWidth) index = Math.floor(index);
            // pass e when click control buttons or keydown
            render(passEventObject || e && e.type === "keydown" ? e : null);
        }
    }
    // on nav click
    function onNavClick(e) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        e = getEvent(e);
        var target = getTarget(e), navIndex;
        // find the clicked nav item
        while(target !== navContainer && !(0, $92c19f95ffd892da$export$5608640b1bf2f6d7)(target, "data-nav"))target = target.parentNode;
        if ((0, $92c19f95ffd892da$export$5608640b1bf2f6d7)(target, "data-nav")) {
            var navIndex = navClicked = Number((0, $36eae2ea1433e2ee$export$6a93fe6b2b4c71a0)(target, "data-nav")), targetIndexBase = fixedWidth || autoWidth ? navIndex * slideCount / pages : navIndex * items, targetIndex = navAsThumbnails ? navIndex : Math.min(Math.ceil(targetIndexBase), slideCount - 1);
            goTo(targetIndex, e);
            if (navCurrentIndex === navIndex) {
                if (animating) stopAutoplay();
                navClicked = -1; // reset navClicked
            }
        }
    }
    // autoplay functions
    function setAutoplayTimer() {
        autoplayTimer = setInterval(function() {
            onControlsClick(null, autoplayDirection);
        }, autoplayTimeout);
        animating = true;
    }
    function stopAutoplayTimer() {
        clearInterval(autoplayTimer);
        animating = false;
    }
    function updateAutoplayButton(action, txt) {
        (0, $fc4786701fd188a9$export$7e45664a2081efb1)(autoplayButton, {
            "data-action": action
        });
        autoplayButton.innerHTML = autoplayHtmlStrings[0] + action + autoplayHtmlStrings[1] + txt;
    }
    function startAutoplay() {
        setAutoplayTimer();
        if (autoplayButton) updateAutoplayButton("stop", autoplayText[1]);
    }
    function stopAutoplay() {
        stopAutoplayTimer();
        if (autoplayButton) updateAutoplayButton("start", autoplayText[0]);
    }
    // programaitcally play/pause the slider
    function play() {
        if (autoplay && !animating) {
            startAutoplay();
            autoplayUserPaused = false;
        }
    }
    function pause() {
        if (animating) {
            stopAutoplay();
            autoplayUserPaused = true;
        }
    }
    function toggleAutoplay() {
        if (animating) {
            stopAutoplay();
            autoplayUserPaused = true;
        } else {
            startAutoplay();
            autoplayUserPaused = false;
        }
    }
    function onVisibilityChange() {
        if (doc.hidden) {
            if (animating) {
                stopAutoplayTimer();
                autoplayVisibilityPaused = true;
            }
        } else if (autoplayVisibilityPaused) {
            setAutoplayTimer();
            autoplayVisibilityPaused = false;
        }
    }
    function mouseoverPause() {
        if (animating) {
            stopAutoplayTimer();
            autoplayHoverPaused = true;
        }
    }
    function mouseoutRestart() {
        if (autoplayHoverPaused) {
            setAutoplayTimer();
            autoplayHoverPaused = false;
        }
    }
    // keydown events on document
    function onDocumentKeydown(e) {
        e = getEvent(e);
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT
        ].indexOf(e.keyCode);
        if (keyIndex >= 0) onControlsClick(e, keyIndex === 0 ? -1 : 1);
    }
    // on key control
    function onControlsKeydown(e) {
        e = getEvent(e);
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT
        ].indexOf(e.keyCode);
        if (keyIndex >= 0) {
            if (keyIndex === 0) {
                if (!prevButton.disabled) onControlsClick(e, -1);
            } else if (!nextButton.disabled) onControlsClick(e, 1);
        }
    }
    // set focus
    function setFocus(el) {
        el.focus();
    }
    // on key nav
    function onNavKeydown(e) {
        e = getEvent(e);
        var curElement = doc.activeElement;
        if (!(0, $92c19f95ffd892da$export$5608640b1bf2f6d7)(curElement, "data-nav")) return;
        // var code = e.keyCode,
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT,
            KEYS.ENTER,
            KEYS.SPACE
        ].indexOf(e.keyCode), navIndex = Number((0, $36eae2ea1433e2ee$export$6a93fe6b2b4c71a0)(curElement, "data-nav"));
        if (keyIndex >= 0) {
            if (keyIndex === 0) {
                if (navIndex > 0) setFocus(navItems[navIndex - 1]);
            } else if (keyIndex === 1) {
                if (navIndex < pages - 1) setFocus(navItems[navIndex + 1]);
            } else {
                navClicked = navIndex;
                goTo(navIndex, e);
            }
        }
    }
    function getEvent(e) {
        e = e || win.event;
        return isTouchEvent(e) ? e.changedTouches[0] : e;
    }
    function getTarget(e) {
        return e.target || win.event.srcElement;
    }
    function isTouchEvent(e) {
        return e.type.indexOf("touch") >= 0;
    }
    function preventDefaultBehavior(e) {
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
    }
    function getMoveDirectionExpected() {
        return (0, $c56a54e7f265475e$export$83b6d73568c72b60)((0, $d546b5ddaa1f720a$export$c796d9d3e501591f)(lastPosition.y - initPosition.y, lastPosition.x - initPosition.x), swipeAngle) === options.axis;
    }
    function onPanStart(e) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        if (autoplay && animating) stopAutoplayTimer();
        panStart = true;
        if (rafIndex) {
            (0, $9960623eeb62d695$export$75aab3dbee8deceb)(rafIndex);
            rafIndex = null;
        }
        var $ = getEvent(e);
        events.emit(isTouchEvent(e) ? "touchStart" : "dragStart", info(e));
        if (!isTouchEvent(e) && [
            "img",
            "a"
        ].indexOf(getLowerCaseNodeName(getTarget(e))) >= 0) preventDefaultBehavior(e);
        lastPosition.x = initPosition.x = $.clientX;
        lastPosition.y = initPosition.y = $.clientY;
        if (carousel) {
            translateInit = parseFloat(container.style[transformAttr].replace(transformPrefix, ""));
            resetDuration(container, "0s");
        }
    }
    function onPanMove(e) {
        if (panStart) {
            var $ = getEvent(e);
            lastPosition.x = $.clientX;
            lastPosition.y = $.clientY;
            if (carousel) {
                if (!rafIndex) rafIndex = (0, $841e85ee868dd0d4$export$27f233d61a9e2fa4)(function() {
                    panUpdate(e);
                });
            } else {
                if (moveDirectionExpected === "?") moveDirectionExpected = getMoveDirectionExpected();
                if (moveDirectionExpected) preventScroll = true;
            }
            if ((typeof e.cancelable !== "boolean" || e.cancelable) && preventScroll) e.preventDefault();
        }
    }
    function panUpdate(e) {
        if (!moveDirectionExpected) {
            panStart = false;
            return;
        }
        (0, $9960623eeb62d695$export$75aab3dbee8deceb)(rafIndex);
        if (panStart) rafIndex = (0, $841e85ee868dd0d4$export$27f233d61a9e2fa4)(function() {
            panUpdate(e);
        });
        if (moveDirectionExpected === "?") moveDirectionExpected = getMoveDirectionExpected();
        if (moveDirectionExpected) {
            if (!preventScroll && isTouchEvent(e)) preventScroll = true;
            try {
                if (e.type) events.emit(isTouchEvent(e) ? "touchMove" : "dragMove", info(e));
            } catch (err) {}
            var x = translateInit, dist = getDist(lastPosition, initPosition);
            if (!horizontal || fixedWidth || autoWidth) {
                x += dist;
                x += "px";
            } else {
                var percentageX = TRANSFORM ? dist * items * 100 / ((viewport + gutter) * slideCountNew) : dist * 100 / (viewport + gutter);
                x += percentageX;
                x += "%";
            }
            container.style[transformAttr] = transformPrefix + x + transformPostfix;
        }
    }
    function onPanEnd(e) {
        if (panStart) {
            if (rafIndex) {
                (0, $9960623eeb62d695$export$75aab3dbee8deceb)(rafIndex);
                rafIndex = null;
            }
            if (carousel) resetDuration(container, "");
            panStart = false;
            var $ = getEvent(e);
            lastPosition.x = $.clientX;
            lastPosition.y = $.clientY;
            var dist = getDist(lastPosition, initPosition);
            if (Math.abs(dist)) {
                // drag vs click
                if (!isTouchEvent(e)) {
                    // prevent "click"
                    var target = getTarget(e);
                    (0, $2d450f9a54805e30$export$aadfb65bee660f96)(target, {
                        "click": function preventClick(e) {
                            preventDefaultBehavior(e);
                            (0, $d58278b019a227a5$export$da5f6eb3bb522cd)(target, {
                                "click": preventClick
                            });
                        }
                    });
                }
                if (carousel) rafIndex = (0, $841e85ee868dd0d4$export$27f233d61a9e2fa4)(function() {
                    if (horizontal && !autoWidth) {
                        var indexMoved = -dist * items / (viewport + gutter);
                        indexMoved = dist > 0 ? Math.floor(indexMoved) : Math.ceil(indexMoved);
                        index += indexMoved;
                    } else {
                        var moved = -(translateInit + dist);
                        if (moved <= 0) index = indexMin;
                        else if (moved >= slidePositions[slideCountNew - 1]) index = indexMax;
                        else {
                            var i = 0;
                            while(i < slideCountNew && moved >= slidePositions[i]){
                                index = i;
                                if (moved > slidePositions[i] && dist < 0) index += 1;
                                i++;
                            }
                        }
                    }
                    render(e, dist);
                    events.emit(isTouchEvent(e) ? "touchEnd" : "dragEnd", info(e));
                });
                else if (moveDirectionExpected) onControlsClick(e, dist > 0 ? -1 : 1);
            }
        }
        // reset
        if (options.preventScrollOnTouch === "auto") preventScroll = false;
        if (swipeAngle) moveDirectionExpected = "?";
        if (autoplay && !animating) setAutoplayTimer();
    }
    // === RESIZE FUNCTIONS === //
    // (slidePositions, index, items) => vertical_conentWrapper.height
    function updateContentWrapperHeight() {
        var wp = middleWrapper ? middleWrapper : innerWrapper;
        wp.style.height = slidePositions[index + items] - slidePositions[index] + "px";
    }
    function getPages() {
        var rough = fixedWidth ? (fixedWidth + gutter) * slideCount / viewport : slideCount / items;
        return Math.min(Math.ceil(rough), slideCount);
    }
    /*
   * 1. update visible nav items list
   * 2. add "hidden" attributes to previous visible nav items
   * 3. remove "hidden" attrubutes to new visible nav items
   */ function updateNavVisibility() {
        if (!nav || navAsThumbnails) return;
        if (pages !== pagesCached) {
            var min = pagesCached, max = pages, fn = (0, $7e4aafbbd7b5f772$export$998191bfdf710c72);
            if (pagesCached > pages) {
                min = pages;
                max = pagesCached;
                fn = (0, $b6b059ab1be1bedb$export$7669482c90f5c50f);
            }
            while(min < max){
                fn(navItems[min]);
                min++;
            }
            // cache pages
            pagesCached = pages;
        }
    }
    function info(e) {
        return {
            container: container,
            slideItems: slideItems,
            navContainer: navContainer,
            navItems: navItems,
            controlsContainer: controlsContainer,
            hasControls: hasControls,
            prevButton: prevButton,
            nextButton: nextButton,
            items: items,
            slideBy: slideBy,
            cloneCount: cloneCount,
            slideCount: slideCount,
            slideCountNew: slideCountNew,
            index: index,
            indexCached: indexCached,
            displayIndex: getCurrentSlide(),
            navCurrentIndex: navCurrentIndex,
            navCurrentIndexCached: navCurrentIndexCached,
            pages: pages,
            pagesCached: pagesCached,
            sheet: sheet,
            isOn: isOn,
            event: e || {}
        };
    }
    return {
        version: "2.9.4",
        getInfo: info,
        events: events,
        goTo: goTo,
        play: play,
        pause: pause,
        isOn: isOn,
        updateSliderHeight: updateInnerWrapperHeight,
        refresh: initSliderTransform,
        destroy: destroy,
        rebuild: function rebuild() {
            return $665047dee130590c$export$51fe319e24d9d8c9((0, $8def800bd2c631ba$export$8b58be045bf06082)(options, optionsElements));
        }
    };
};


function $b66c6eb8fd145830$export$98e485a858f88afc(el) {
    var element = document.querySelector(el);
    // don't start function if the element is not on the page
    if (!element) return;
    (0, $665047dee130590c$export$51fe319e24d9d8c9)({
        container: el,
        items: 1,
        mouseDrag: true,
        autoplay: false,
        autoHeight: true,
        autoplayTimeout: 7500,
        controls: false,
        nav: true
    });
}



(0, $6e15c66c5bf5d010$export$5dacdde460c8d918)();
function $9b6240db347cac8f$export$2e2bcd8739ae039() {
    var faqTitles = document.querySelectorAll(".faq-item__title");
    // stop function if there're no FAQ on the page
    if (!faqTitles) return;
    // Toggle item state
    faqTitles.forEach(function(item) {
        item.addEventListener("click", function() {
            item.parentNode.classList.toggle("active");
        });
    });
}


var $cf7d6b8f24e62a24$var$version = "0.3.1", $cf7d6b8f24e62a24$var$classCallCheck = function classCallCheck(e, o) {
    if (!(e instanceof o)) throw new TypeError("Cannot call a class as a function");
}, $cf7d6b8f24e62a24$var$createClass = function() {
    function e(e, o) {
        for(var t = 0; t < o.length; t++){
            var i = o[t];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
        }
    }
    return function(o, t, i) {
        return t && e(o.prototype, t), i && e(o, i), o;
    };
}(), $cf7d6b8f24e62a24$var$toConsumableArray = function toConsumableArray(e) {
    if (Array.isArray(e)) {
        for(var o = 0, t = Array(e.length); o < e.length; o++)t[o] = e[o];
        return t;
    }
    return Array.from(e);
}, $cf7d6b8f24e62a24$var$MicroModal = function() {
    var e = [
        "a[href]",
        "area[href]",
        'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
        "select:not([disabled]):not([aria-hidden])",
        "textarea:not([disabled]):not([aria-hidden])",
        "button:not([disabled]):not([aria-hidden])",
        "iframe",
        "object",
        "embed",
        "[contenteditable]",
        '[tabindex]:not([tabindex^="-"])'
    ], o = function() {
        function o(e) {
            var t = e.targetModal, i = e.triggers, n = void 0 === i ? [] : i, a = e.onShow, r = void 0 === a ? function r() {} : a, s = e.onClose, l = void 0 === s ? function l() {} : s, c = e.openTrigger, d = void 0 === c ? "data-micromodal-trigger" : c, u = e.closeTrigger, h = void 0 === u ? "data-micromodal-close" : u, f = e.disableScroll, v = void 0 !== f && f, g = e.disableFocus, m = void 0 !== g && g, b = e.awaitCloseAnimation, y = void 0 !== b && b, k = e.debugMode, w = void 0 !== k && k;
            $cf7d6b8f24e62a24$var$classCallCheck(this, o), this.modal = document.getElementById(t), this.config = {
                debugMode: w,
                disableScroll: v,
                openTrigger: d,
                closeTrigger: h,
                onShow: r,
                onClose: l,
                awaitCloseAnimation: y,
                disableFocus: m
            }, n.length > 0 && this.registerTriggers.apply(this, $cf7d6b8f24e62a24$var$toConsumableArray(n)), this.onClick = this.onClick.bind(this), this.onKeydown = this.onKeydown.bind(this);
        }
        return $cf7d6b8f24e62a24$var$createClass(o, [
            {
                key: "registerTriggers",
                value: function value() {
                    for(var e = this, _$o = arguments.length, t = Array(_$o), i = 0; i < _$o; i++)t[i] = arguments[i];
                    t.forEach(function(o) {
                        o.addEventListener("click", function() {
                            return e.showModal();
                        });
                    });
                }
            },
            {
                key: "showModal",
                value: function value() {
                    this.activeElement = document.activeElement, this.modal.setAttribute("aria-hidden", "false"), this.modal.classList.add("is-open"), this.setFocusToFirstNode(), this.scrollBehaviour("disable"), this.addEventListeners(), this.config.onShow(this.modal);
                }
            },
            {
                key: "closeModal",
                value: function value() {
                    var e = this.modal;
                    this.modal.setAttribute("aria-hidden", "true"), this.removeEventListeners(), this.scrollBehaviour("enable"), this.activeElement.focus(), this.config.onClose(this.modal), this.config.awaitCloseAnimation ? this.modal.addEventListener("animationend", function o() {
                        e.classList.remove("is-open"), e.removeEventListener("animationend", o, !1);
                    }, !1) : e.classList.remove("is-open");
                }
            },
            {
                key: "scrollBehaviour",
                value: function value(e) {
                    if (this.config.disableScroll) {
                        var _$o = document.querySelector("body");
                        switch(e){
                            case "enable":
                                Object.assign(_$o.style, {
                                    overflow: "initial",
                                    height: "initial"
                                });
                                break;
                            case "disable":
                                Object.assign(_$o.style, {
                                    overflow: "hidden",
                                    height: "100vh"
                                });
                        }
                    }
                }
            },
            {
                key: "addEventListeners",
                value: function value() {
                    this.modal.addEventListener("touchstart", this.onClick), this.modal.addEventListener("click", this.onClick), document.addEventListener("keydown", this.onKeydown);
                }
            },
            {
                key: "removeEventListeners",
                value: function value() {
                    this.modal.removeEventListener("touchstart", this.onClick), this.modal.removeEventListener("click", this.onClick), document.removeEventListener("keydown", this.onKeydown);
                }
            },
            {
                key: "onClick",
                value: function value(e) {
                    e.target.hasAttribute(this.config.closeTrigger) && (this.closeModal(), e.preventDefault());
                }
            },
            {
                key: "onKeydown",
                value: function value(e) {
                    27 === e.keyCode && this.closeModal(e), 9 === e.keyCode && this.maintainFocus(e);
                }
            },
            {
                key: "getFocusableNodes",
                value: function value() {
                    var _$o = this.modal.querySelectorAll(e);
                    return Object.keys(_$o).map(function(e) {
                        return _$o[e];
                    });
                }
            },
            {
                key: "setFocusToFirstNode",
                value: function value() {
                    if (!this.config.disableFocus) {
                        var e = this.getFocusableNodes();
                        e.length && e[0].focus();
                    }
                }
            },
            {
                key: "maintainFocus",
                value: function value(e) {
                    var _$o = this.getFocusableNodes();
                    if (this.modal.contains(document.activeElement)) {
                        var t = _$o.indexOf(document.activeElement);
                        e.shiftKey && 0 === t && (_$o[_$o.length - 1].focus(), e.preventDefault()), e.shiftKey || t !== _$o.length - 1 || (_$o[0].focus(), e.preventDefault());
                    } else _$o[0].focus();
                }
            }
        ]), o;
    }(), t = null, i = function i(e, o) {
        var t = [];
        return e.forEach(function(e) {
            var i = e.attributes[o].value;
            void 0 === t[i] && (t[i] = []), t[i].push(e);
        }), t;
    }, n = function n(e) {
        if (!document.getElementById(e)) return console.warn("MicroModal v" + $cf7d6b8f24e62a24$var$version + ": \u2757Seems like you have missed %c'" + e + "'", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "ID somewhere in your code. Refer example below to resolve it."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<div class="modal" id="' + e + '"></div>'), !1;
    }, a = function a(e) {
        if (e.length <= 0) return console.warn("MicroModal v" + $cf7d6b8f24e62a24$var$version + ": \u2757Please specify at least one %c'micromodal-trigger'", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "data attribute."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<a href="#" data-micromodal-trigger="my-modal"></a>'), !1;
    }, r = function r(e, o) {
        if (a(e), !o) return !0;
        for(var t in o)n(t);
        return !0;
    };
    return {
        init: function init(e) {
            var t = Object.assign({}, {
                openTrigger: "data-micromodal-trigger"
            }, e), n = [].concat($cf7d6b8f24e62a24$var$toConsumableArray(document.querySelectorAll("[" + t.openTrigger + "]"))), a = i(n, t.openTrigger);
            if (!0 !== t.debugMode || !1 !== r(n, a)) for(var s in a){
                var l = a[s];
                t.targetModal = s, t.triggers = [].concat($cf7d6b8f24e62a24$var$toConsumableArray(l)), new o(t);
            }
        },
        show: function show(e, i) {
            var a = i || {};
            a.targetModal = e, !0 === a.debugMode && !1 === n(e) || (t = new o(a)).showModal();
        },
        close: function close() {
            t.closeModal();
        }
    };
}();
var $cf7d6b8f24e62a24$export$2e2bcd8739ae039 = $cf7d6b8f24e62a24$var$MicroModal;



(0, $cf7d6b8f24e62a24$export$2e2bcd8739ae039).init();
(0, $6e15c66c5bf5d010$export$5dacdde460c8d918)();
function $badbc7103c38ee38$export$2b9594e9123c5dce(el) {
    // don't run function if not on product page
    if (!document.querySelector(el)) return;
    // set variables
    var version = document.querySelector(".version2");
    var radios = document.querySelectorAll('input[type="radio"]');
    var steps = document.querySelectorAll(".wc-pao-addon");
    var prevBtn = document.querySelector(".link#prev");
    var nextBtn = document.querySelector(".btn#next");
    var cartBtn = document.querySelector('button[name="add-to-cart"]');
    var i = 0;
    steps[0].classList.add("current");
    // Loop over radio buttons and add class to parent <label> when checked
    radios.forEach(function(radio) {
        radio.parentNode.classList.add("radio-container");
        radio.addEventListener("click", function() {
            var current = document.getElementsByClassName("active");
            if (current.length) current[0].className = current[0].className.replace(" active", "");
            radio.parentNode.className += " active";
        });
    });
    // set initial progress state
    var setProgress = function(i) {
        var progress = document.querySelector(".modal-progress");
        var items = steps.length;
        for(var _$i = 0; _$i < items; _$i++){
            var newItem = document.createElement("p");
            var node = document.createTextNode(_$i + 1);
            if (_$i === 0) newItem.classList = "modal-progress__item modal-progress__item--active";
            else newItem.classList = "modal-progress__item";
            newItem.appendChild(node);
            progress.appendChild(newItem);
        }
        updateProgress(i);
    };
    // update the state with new index
    var updateProgress = function(i) {
        // update the progress bar (dots)
        var progressItems = document.querySelectorAll(".modal-progress__item");
        progressItems[i].classList.add("modal-progress__item--active");
        // show the current product-addon div
        steps[i].classList.add("current");
        // hide prev if the first step and hide next if it's the last step
        if (i === 0) prevBtn.style.visibility = "hidden";
        else prevBtn.style.visibility = "visible";
        if (i === steps.length - 1) {
            nextBtn.style.visibility = "hidden";
            cartBtn.style.display = "inline-block";
        } else {
            nextBtn.style.visibility = "visible";
            cartBtn.style.display = "none";
        }
        // get all input fields from current step
        var stepItems = steps[i].querySelectorAll("input");
        // disable button if there's no radio selected on a requried step
        if (!checkIfRequired(steps[i]) && !version) {
            nextBtn.setAttribute("disabled", "disabled");
            cartBtn.setAttribute("disabled", "disabled");
        }
        stepItems.forEach(function(item) {
            item.addEventListener("click", function() {
                nextBtn.removeAttribute("disabled");
                cartBtn.removeAttribute("disabled");
            });
        });
    };
    // check if a form field is required and, if so, disable the button
    var checkIfRequired = function(item) {
        if (!item.classList.contains("wc-pao-required-addon")) return true;
        else {
            var requiredItems = item.querySelectorAll("input");
            var status = false;
            requiredItems.forEach(function(item) {
                if (item.checked === true) status = true;
            });
            return status;
        }
    };
    setProgress(i);
    prevBtn.addEventListener("click", function() {
        steps[i].classList.remove("current");
        i--;
        updateProgress(i);
    });
    nextBtn.addEventListener("click", function() {
        if (!checkIfRequired(steps[i])) return;
        steps[i].classList.remove("current");
        i++;
        updateProgress(i);
    });
    cartBtn.addEventListener("click", function(e) {
        if (!checkIfRequired(steps[i])) e.preventDefault();
    });
}


function $029b5235592d4bc9$export$2e2bcd8739ae039(el, iframe) {
    el && el.addEventListener("click", function() {
        return el.innerHTML = iframe;
    });
}


// Object-fit fix
(0, (/*@__PURE__*/$parcel$interopDefault($31467fba5e5d38e9$exports)))();
(0, $b66c6eb8fd145830$export$98e485a858f88afc)(".testimonial-slider");
var $c55bff8fb8cf358b$var$navs = document.querySelectorAll(".tns-nav");
for(var $c55bff8fb8cf358b$var$i = 0; $c55bff8fb8cf358b$var$i < $c55bff8fb8cf358b$var$navs.length; $c55bff8fb8cf358b$var$i++)$c55bff8fb8cf358b$var$navs[$c55bff8fb8cf358b$var$i].parentNode.appendChild($c55bff8fb8cf358b$var$navs[$c55bff8fb8cf358b$var$i]);
(0, $badbc7103c38ee38$export$2b9594e9123c5dce)("form.cart");
(0, $9b6240db347cac8f$export$2e2bcd8739ae039)();
if (document.querySelector(".video")) {
    var $c55bff8fb8cf358b$var$videoDiv = document.querySelector(".video");
    var $c55bff8fb8cf358b$var$iframeHTML = document.getElementById("video__iframe").innerHTML;
    (0, $029b5235592d4bc9$export$2e2bcd8739ae039)($c55bff8fb8cf358b$var$videoDiv, $c55bff8fb8cf358b$var$iframeHTML);
}

})();
//# sourceMappingURL=app.js.map
